var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashHeroCrypto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 439.99,
    cy: 140.15,
    r: 32.15,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.6,
    cy: 136.26,
    r: 32.15,
    transform: "translate(132.39 478.95) rotate(-65.35)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.57,
    cy: 135.9,
    rx: 23.89,
    ry: 24.5,
    transform: "translate(170.3 508.97) rotate(-71.36)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,158.44a24.49,24.49,0,0,1-15.58-30.37c-.08.22-.17.44-.24.66a24.49,24.49,0,0,0,46.41,15.66l.21-.67A24.49,24.49,0,0,1,432,158.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.17,113.35a24.49,24.49,0,0,1,15.59,30.37l.24-.66a24.49,24.49,0,0,0-46.42-15.65c-.07.22-.13.44-.2.66A24.48,24.48,0,0,1,447.17,113.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.44,146.58c1.1-3.26.25-5.89-1.74-7.53a6.58,6.58,0,0,0,4.6-4.58c1.08-3.21.06-6.09-3.06-8l1.34-4-3.66-1.23L445.68,125l-2.07-.7,1.24-3.67-3.65-1.23L440,123l-3.33-1.12-2.32-.78-1.23,3.65,2.32.78-6,17.77-2.57-.87-1.23,3.65,2.56.87h0l3.33,1.12-1.44,4.28,3.65,1.23,1.44-4.28,2.08.7-1.45,4.28,3.66,1.23,1.49-4.42C445.24,152,448.18,150.29,449.44,146.58ZM440,127.13,445,128.8c2.75.93,3.92,2.6,3.13,4.93s-2.71,2.91-5.46,2L437,133.82l2.33-6.91Zm-.26,19.7-6-2-.42-.14,2.44-7.23,6.4,2.16c3,1,4.23,2.66,3.39,5.17S442.76,147.84,439.77,146.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08,120c-.08.23-1.59-.06-3.84-.68L440,119c-.3,1.08-.68,2.35-1.13,3.72l-.21.65-.67-.22-1-.32c-1.73-.59-3.32-1.17-4.63-1.69l.74-.36c-.87,2.16-1.56,3.54-1.78,3.46s.05-1.59.68-3.84l.14-.52.59.16c1.36.38,3,.88,4.7,1.46l1,.33-.89.44c.48-1.35.94-2.6,1.35-3.64l.23-.56.51.2C441.78,119.08,443.15,119.77,443.08,120Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.55,122.25c-.13.37-1.21.33-2.43-.08s-2.11-1-2-1.41,1.21-.33,2.43.09S449.67,121.89,449.55,122.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,142.42c-.37-.13.65-4.13,2.27-8.94s3.24-8.6,3.6-8.48-.65,4.12-2.27,8.93S427.89,142.54,427.53,142.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.71,135.77c-.13.37-1.81.13-3.75-.52s-3.43-1.49-3.3-1.86,1.8-.13,3.75.53S442.83,135.41,442.71,135.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.18,146.66c-.12.37-1.8.14-3.74-.52s-3.43-1.49-3.3-1.85,1.8-.14,3.74.52S439.31,146.3,439.18,146.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.82,
    cy: 55.46,
    r: 23.15,
    transform: "translate(-3.35 71.54) rotate(-9.72)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.88,
    cy: 53.42,
    r: 23.15,
    transform: "translate(234.35 432.01) rotate(-71.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.71,
    cy: 53.22,
    rx: 17.64,
    ry: 17.2,
    transform: "matrix(0.95, -0.32, 0.32, 0.95, 5.3, 138.22)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.27,69.43A17.64,17.64,0,0,1,400,59l.15.47A17.64,17.64,0,1,0,433.55,48c-.05-.16-.12-.31-.17-.47A17.64,17.64,0,0,1,422.27,69.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.14,37A17.64,17.64,0,0,1,433.38,47.5c-.05-.16-.1-.32-.16-.48a17.64,17.64,0,0,0-33.36,11.45L400,59A17.63,17.63,0,0,1,411.14,37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,55a4.67,4.67,0,0,0-4.3-3.53,4.74,4.74,0,0,0,.62-4.64,4.61,4.61,0,0,0-5.26-3.21l-1-2.84-2.63.9.91,2.64-1.49.52L413,42.17l-2.62.9.9,2.65-2.39.82-1.66.57.9,2.63,1.66-.58,4.39,12.77-1.84.63.9,2.63,1.84-.63h0l2.39-.82,1.06,3.07,2.62-.9-1-3.08,1.49-.51,1.05,3.08,2.63-.91-1.09-3.17C427,59.89,428,57.65,427,55Zm-13.91-7,3.56-1.22c2-.68,3.37-.24,3.94,1.44s-.27,2.85-2.24,3.53l-4,1.38-1.71-5Zm8.51,11.35-4.3,1.48-.3.1-1.79-5.2,4.6-1.58c2.15-.73,3.59-.34,4.21,1.47S423.78,58.63,421.63,59.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,42.61c0,.16-.93.66-2.49,1.3l.26-.53c.3.74.64,1.64,1,2.61l.17.47-.48.17-.7.24c-1.25.43-2.41.8-3.38,1.07l.26-.53c.45,1.62.67,2.71.5,2.76s-.66-.93-1.29-2.49l-.15-.36.41-.17c.93-.38,2.08-.8,3.32-1.23l.71-.24-.32.64c-.32-1-.6-1.9-.82-2.67l-.12-.42.38-.11C410.59,42.66,411.67,42.45,411.73,42.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.41,41.05c.09.27-.55.73-1.42,1s-1.66.33-1.75.06.54-.72,1.42-1S416.32,40.79,416.41,41.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.7,62.23c-.26.09-1.44-2.64-2.62-6.09s-1.94-6.34-1.68-6.43,1.44,2.64,2.63,6.1S413,62.14,412.7,62.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.44,51.77c.09.27-1,.87-2.37,1.35s-2.6.66-2.69.39,1-.86,2.37-1.34S418.35,51.51,418.44,51.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.22,59.54c.09.26-1,.86-2.37,1.34s-2.61.66-2.7.39,1-.86,2.37-1.34S421.13,59.27,421.22,59.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.01 44.98 146.05 44.98 146.05 167.38 52.64 166.9 52.01 44.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.6,
    y: 44.98,
    width: 93.5,
    height: 121.47,
    transform: "translate(186.69 211.42) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.56,44.51v122.4H46.13V44.51ZM139.63,166V45.44H47.06V166Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.21,
    y: 58.13,
    width: 71.58,
    height: 95.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,58.13s0,.16,0,.47,0,.75,0,1.33c0,1.19,0,2.93,0,5.19,0,4.53,0,11.14.06,19.51,0,16.74.06,40.5.1,68.66l-.21-.22,71.57,0h0l-.24.24c0-35.44,0-68.28,0-95.16l.2.2-52-.1-14.47,0-3.81,0-1.32,0,1.27,0,3.78,0L75.69,58l52.1-.1H128v.19c0,26.88,0,59.72,0,95.16v.24h-.25l-71.57,0H56v-.22c0-28.22.08-52,.11-68.8,0-8.35,0-14.94,0-19.46,0-2.24,0-4,0-5.14,0-.58,0-1,0-1.32S56.21,58.13,56.21,58.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.38,166.44a12.54,12.54,0,0,1,1.26-2.05c.83-1.23,2-2.92,3.36-4.74s2.62-3.44,3.57-4.59a10.84,10.84,0,0,1,1.64-1.77,13.17,13.17,0,0,1-1.37,2l-3.46,4.65-3.46,4.66A12,12,0,0,1,46.38,166.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,45a71.48,71.48,0,0,1,5,6.43,74,74,0,0,1,4.61,6.72,67.42,67.42,0,0,1-5-6.43A66.57,66.57,0,0,1,46.6,45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.09,
    y1: 44.98,
    x2: 127.79,
    y2: 58.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,58.62a85,85,0,0,1,6-7A87.32,87.32,0,0,1,140.09,45a87,87,0,0,1-6,7A87.32,87.32,0,0,1,127.79,58.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,166.44A79,79,0,0,1,134,160.1a79,79,0,0,1-5.7-6.68,81.4,81.4,0,0,1,6.06,6.35A80.8,80.8,0,0,1,140.09,166.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,75.89c1.48.76,2.89.25,4.38-.07,3.79-.82,6.62.06,10,2.79,2.52-.06,4.9-.69,6.93,1.16.2.17.56.16.84.25.48.16.95.34,1.42.51l-.08.23-1.4-.4-.15.26c.2.15.39.39.61.42,3.61.58,5,3,3.57,6.31.5.62,1.35,1.15.89,2.3-.13-.85-.33-1.55-1.42-1.75a5.07,5.07,0,0,1,1.18,5,5.14,5.14,0,0,1-3.75,3.47l1.11.36,0,.18-1.75-.33a47.51,47.51,0,0,0-.45,5.22c.14,6-2.44,9.72-8.4,11.93A3.08,3.08,0,0,0,99.07,117a10.25,10.25,0,0,0,2.16,6.17c1,1.43,2.15,2.74,3.34,4.22a35.11,35.11,0,0,0-17.65,10,46.3,46.3,0,0,0,1.83-6.11A20.18,20.18,0,0,0,87,119.41c-1-2.25-2.81-3.09-5.29-2.8-1.18.13-2.35.33-3.53.41-1.91.12-3.24-.66-3.53-2.07a4.64,4.64,0,0,1,.1-1.65,2.38,2.38,0,0,0-.57-2.4c-.71-.67-.29-1.43.29-2.19-1.27-.38-1.21-1.25-.84-2.22a1.28,1.28,0,0,0-.71-1.78c-1.55-.85-1.64-1.92-.43-3.22,1.08-1.15,2.07-2.39,3.09-3.57l-1.8-1.35.15-.21a2.16,2.16,0,0,0,.55.27,2.06,2.06,0,0,0,1,0c.09,0,.09-.49,0-.74a17.65,17.65,0,0,1,1.29-10.53,1.11,1.11,0,0,0,.09-.77c-1.59-4,.08-5.47,2.4-7.34a10,10,0,0,1,8.46-2H85.54l0,.14,2.41.57-2.48-.17A6.74,6.74,0,0,0,80.84,77c2.77-1.1,5.43-.45,8.31-.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,358.83a38.38,38.38,0,0,0-16.39-5.64c-2.67-.27-5.6-.2-7.75,1.43a1.57,1.57,0,0,0-.79,1.41,1.74,1.74,0,0,0,.75,1c6.67,5.08,16.75,5.73,24.18,1.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,358.37a80.94,80.94,0,0,1-10.59-9.31,26.78,26.78,0,0,1-6.63-12.27c-.28-1.4-.37-3,.53-4.11,8.43,6.59,15,15.11,16.69,25.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,358.77a38.41,38.41,0,0,1,.19-13.9,18.81,18.81,0,0,1,7.4-11.46c1.46,3.41.84,7.33-.19,10.89a53.14,53.14,0,0,1-7.34,15.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,373.58c-5,.61-9.39,3.26-13.14,6.65a24.89,24.89,0,0,0-7.52,12.9c4.93-.3,9.1-3.77,12.13-7.67s5.13-8.16,8.46-11.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.67,376a32.41,32.41,0,0,1,3.74-30.65C71.27,355.47,70.22,367,64.67,376",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6,389a23.45,23.45,0,0,0-22.41,12.9c-.27.55-.52,1.26-.15,1.75a1.7,1.7,0,0,0,1.49.44c4.41-.29,8.33-2.94,11.56-6s6-6.52,9.61-9.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.25,388.25a41.72,41.72,0,0,1-.42-23.31c.82-3,2.2-6.16,5-7.56a1,1,0,0,1,.76-.14,1,1,0,0,1,.48.56,14.14,14.14,0,0,1,1.17,6.69,41.07,41.07,0,0,1-1,6.77c-.87,4.13-1.34,8.58-3.6,12.15a24.58,24.58,0,0,0-1.45,2.67c-.43.9-.43,1.22-.82,1.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.17,392.56c-2.15-8.15.13-18,5.26-24.71.38-.49.88-1,1.5-1,.95.08,1.19,1.35,1.15,2.29a44.67,44.67,0,0,1-7.91,23.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,394.34c9.9,2.58,21.26.07,29.5-6a23.91,23.91,0,0,0-16-2c-5.33,1.22-10.21,3.61-13.53,8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,388.92c5.55-9.05,16.18-14.95,26.77-15.48-1.22,4.3-4.76,7.65-8.76,9.68s-8.45,2.9-12.84,3.75c-1.71.34-4.06.7-5.17,2.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,362.59c1.5-5.15,3-10.34,3.42-15.68S107.79,336,105,331.4c-5.18,10-5.71,21.73-.46,31.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,353.77c6.05-11,18.41-19.8,30.92-21-4.83,12-18,21.29-30.92,21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,355.93c9,1.37,16.74,7.14,25.18,10.64a11.18,11.18,0,0,0,5.69,1.09,4.93,4.93,0,0,0,4.28-3.46,5,5,0,0,0-1.49-4.42,12.33,12.33,0,0,0-4.14-2.51c-9.19-3.82-19.05-3.92-28.74-1.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.12,362.26c2,.59,2.74,1.65,4.36,3a47.06,47.06,0,0,0,19.09,9.8c.73.18,1.69.26,2.05-.4s-.09-1.27-.5-1.79a26.26,26.26,0,0,0-11.52-7.82c-4.41-1.64-8.22-3.62-13.48-3.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,324a36.15,36.15,0,0,0,27.69,9.42,1.89,1.89,0,0,0,1.26-.45c.7-.76-.13-1.93-.95-2.56-8.14-6.35-18-9-28-6.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.21,321.44a38.59,38.59,0,0,1,34.56-5.7c-4.35,4.28-10.39,6.59-16.47,7.22a52.11,52.11,0,0,1-18.09-1.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.43,303.85c-.8-8.12-.28-14.54-.84-22.71,0-.65-.19-1.43-.8-1.67-.85-.33-1.56.72-1.83,1.59a26,26,0,0,0,3.46,22.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,304.75c5.51-3.41,9.64-7.85,13.46-13.08,2.66-3.64,4.9-8,4.3-12.47A12.87,12.87,0,0,0,118.9,284a26.86,26.86,0,0,0-5,10c-1.08,3.57-1.84,7.25-3.1,10.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.08,301.08a108.83,108.83,0,0,0,33.13-19.54c-4-1.59-8.49-.64-12.45,1-9,3.65-16.42,9.81-20.86,18.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,309.2c6.11.67,12.33,1.1,18.39.09s11.61-3.36,17.18-5.71a2,2,0,0,0,1.17-.89,1.36,1.36,0,0,0-.42-1.47,3.54,3.54,0,0,0-1.47-.68c-6.06-1.7-12.6-.9-18.56,1.11a86,86,0,0,0-16.29,7.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.64,324.27c-4.17-8.42-3.9-18.25-.29-26.93,2.53,3.87,2.84,8.79,2.38,13.39s-1.87,9.34-2,14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,315.87a37.54,37.54,0,0,0-27.91,11.89c5.2.82,10.55-.53,15.28-2.84s8.94-5.55,13.1-8.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.76,312.12c-5.09-.41-10-1.05-14.9.46s-9.36,4.91-11.35,9.63a27,27,0,0,0,14-2.64,79.73,79.73,0,0,0,12.28-7.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.36,312.29c-4.59-3-9.29-6.06-14.63-7.31s-11.53-.32-15.25,3.7c4.32,2.54,9.56,2.84,14.57,2.83s11.16-.06,15.88,1.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.39,312.53c-7.84-7.69-10.81-21.52-7.66-32a48.89,48.89,0,0,1,7.66,32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.94,290.72c1.48-3.43,2.52-7,3.84-10.54a30.33,30.33,0,0,1,5.49-9.72,14.43,14.43,0,0,1,9.7-5,39.06,39.06,0,0,1-18.84,25.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,295.27c-2.45-3.37-5.27-7.94-8.59-10.45s-7.64-4-11.69-3.07A27.22,27.22,0,0,0,86,295.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.82,291A58.33,58.33,0,0,1,83,278.48c-.65-4.33-.25-9,2-12.73,4.31,8.13,5.69,16.86,2.13,25.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,265.75c2.44-8.07,9.82-14,17.79-16.73a6.73,6.73,0,0,1,3.12-.47,2.72,2.72,0,0,1,2.3,1.92c.29,1.38-.84,2.6-1.91,3.52A60.76,60.76,0,0,1,90,265.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,259.15c.31-5.2.63-10.47,2.32-15.4s5-9.54,9.69-11.7c.81,5.25-1.51,10.48-4.3,15s-6.16,8.79-7.84,13.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.94,262.73c-2-5.88-2.22-13.34-5.74-18.46-2.46-3.58-6.4-6-8.52-9.8a14.87,14.87,0,0,0,.5,11.13,32.1,32.1,0,0,0,6.51,9.32c2.6,2.78,4.83,4.87,7.25,7.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,435.78c-.16,0-.29-39.2-.3-87.54s.1-87.56.26-87.56.29,39.2.3,87.56S90.14,435.78,90,435.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,318.36a8.52,8.52,0,0,1-1.48.55l-4.05,1.37c-3.42,1.17-8.12,2.85-13.22,4.94S95.68,329.15,93,331.5a9.07,9.07,0,0,0-2.52,3.33c-.39.92-.46,1.48-.51,1.47s0-.14,0-.41a5.39,5.39,0,0,1,.29-1.14,8.79,8.79,0,0,1,2.45-3.55,22.2,22.2,0,0,1,5.43-3.38c2.18-1,4.59-2.07,7.14-3.12,5.12-2.1,9.85-3.73,13.31-4.8,1.73-.54,3.14-.94,4.12-1.2A8.64,8.64,0,0,1,124.24,318.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,290.78a3,3,0,0,1-.42.44l-1.26,1.18-4.69,4.27-15.63,13.91c-6.1,5.43-11.38,10.62-15,14.53-1.83,1.95-3.27,3.57-4.25,4.7l-1.14,1.29c-.26.3-.41.45-.42.43A2.39,2.39,0,0,1,93,331c.24-.31.59-.78,1.06-1.36.93-1.18,2.33-2.84,4.13-4.83a196,196,0,0,1,14.94-14.68c6.12-5.42,11.7-10.28,15.74-13.79l4.82-4.13,1.33-1.11C135.28,290.89,135.45,290.76,135.47,290.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,316.11c-.16-.08,1.12-3,2.39-6.74s1.88-6.86,2-6.84a22.79,22.79,0,0,1-1.51,7,47,47,0,0,1-1.89,4.71A7.4,7.4,0,0,1,106.88,316.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,339.83a5.62,5.62,0,0,1-.94-1.09l-2.41-3.09c-2-2.61-4.82-6.22-8-10.17s-6-7.5-8.1-10.06l-2.46-3.05a6.78,6.78,0,0,1-.85-1.16,6.6,6.6,0,0,1,1,1c.63.68,1.52,1.68,2.6,2.93,2.17,2.5,5.1,6,8.25,10S85,332.73,87,335.41c1,1.34,1.74,2.43,2.26,3.2A8.23,8.23,0,0,1,90,339.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,330.19a13.88,13.88,0,0,1-3.14-5.89,16.89,16.89,0,0,1-.72-5.94l.25,0c-.11.45-.19.69-.23.69s0-.26,0-.73l.25,0a27.13,27.13,0,0,0,1,5.78C80.91,327.64,82.66,330.09,82.5,330.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.81,318a10.58,10.58,0,0,0-2.2-1.27,14.62,14.62,0,0,0-6.1-.49,38.06,38.06,0,0,0-6.14,1,17.77,17.77,0,0,1-2.53.61,8.41,8.41,0,0,1,2.42-1,27.72,27.72,0,0,1,6.21-1.17,13.23,13.23,0,0,1,6.29.67A4,4,0,0,1,72.81,318Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,315c0,.08-1.28-.52-3.37-1.23a33.78,33.78,0,0,0-17-1.29c-2.17.39-3.48.79-3.51.7a3.06,3.06,0,0,1,.89-.38,20.68,20.68,0,0,1,2.54-.72,30.21,30.21,0,0,1,8.69-.6,29.88,29.88,0,0,1,8.49,1.91,21.31,21.31,0,0,1,2.4,1.09C70.23,314.82,70.53,315,70.51,315Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.94,302.53A69.07,69.07,0,0,1,87.49,294a69.28,69.28,0,0,1-1.91-8.67A70.6,70.6,0,0,1,88,293.87,70.74,70.74,0,0,1,89.94,302.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,302.53c-.17.06-.88-2.49-2.72-5.1a22.39,22.39,0,0,0-4-4.13,3.74,3.74,0,0,1,1.55.79,12.56,12.56,0,0,1,2.92,3A11.39,11.39,0,0,1,90.1,302.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,414.89c-.06,0-.18-.95-.62-2.61a36.79,36.79,0,0,0-2.62-6.79C84,400,79.11,392.94,72.84,385.91c-3.1-3.54-6.11-6.89-8.67-10.09A70.92,70.92,0,0,1,58,366.88a42.35,42.35,0,0,1-3.13-6.63c-.29-.82-.5-1.46-.62-1.9a3.31,3.31,0,0,1-.16-.68s.34.9,1,2.5a50.15,50.15,0,0,0,3.27,6.51,74.65,74.65,0,0,0,6.26,8.81c2.57,3.17,5.58,6.5,8.69,10.05,6.28,7,11.2,14.15,13.83,19.78a34,34,0,0,1,2.48,6.91,18.5,18.5,0,0,1,.34,2A3.06,3.06,0,0,1,90,414.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.94,379.92a16.68,16.68,0,0,1-1.63.91,35.91,35.91,0,0,0-4.2,2.79,46.5,46.5,0,0,0-5.53,5c-1.94,2-3.94,4.42-6,7-4.08,5.12-7.89,9.65-10.17,13.26-1.16,1.79-2,3.3-2.56,4.36a13.39,13.39,0,0,1-.89,1.64,1.31,1.31,0,0,1,.15-.46c.12-.29.29-.73.55-1.27a38.88,38.88,0,0,1,2.41-4.48c2.22-3.7,6-8.29,10.07-13.4,2-2.55,4.07-4.94,6-7a44.66,44.66,0,0,1,5.67-5,29.44,29.44,0,0,1,4.34-2.65c.54-.27,1-.44,1.27-.56A2,2,0,0,1,120.94,379.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.54,391.27a23.73,23.73,0,0,1-3.43.49,45.61,45.61,0,0,0-8.13,1.61,24.39,24.39,0,0,0-7.28,3.82c-1.68,1.29-2.47,2.37-2.55,2.3a2.55,2.55,0,0,1,.51-.78,12.14,12.14,0,0,1,1.78-1.83,22,22,0,0,1,7.37-4.05,36.39,36.39,0,0,1,8.26-1.46A17.74,17.74,0,0,1,121.54,391.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15,398.25c-.18-.1,1.37-2.46,2.57-5.64s1.38-6,1.59-6a5.51,5.51,0,0,1-.06,1.84,20.19,20.19,0,0,1-1,4.33,21.22,21.22,0,0,1-2,4A5.5,5.5,0,0,1,101.15,398.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,349.47a2.21,2.21,0,0,1-.55.29l-1.61.74c-.7.3-1.56.68-2.53,1.19s-2.1,1-3.27,1.72l-1.87,1.07c-.65.37-1.29.81-2,1.24-1.38.84-2.76,1.87-4.23,2.92a72.35,72.35,0,0,0-16.31,16.88c-1,1.51-2,2.92-2.78,4.33-.4.7-.82,1.35-1.17,2l-1,1.91c-.67,1.2-1.14,2.35-1.61,3.33s-.83,1.85-1.11,2.57-.5,1.2-.67,1.64a2.49,2.49,0,0,1-.28.55,2.44,2.44,0,0,1,.17-.59c.15-.45.34-1,.58-1.68a26.71,26.71,0,0,1,1-2.61c.44-1,.89-2.17,1.54-3.39.31-.62.64-1.26,1-1.93s.76-1.34,1.16-2.05c.78-1.43,1.75-2.86,2.75-4.39a75.7,75.7,0,0,1,7.49-9.2,74.93,74.93,0,0,1,8.94-7.8c1.49-1.05,2.89-2.07,4.29-2.9.69-.42,1.35-.86,2-1.22l1.9-1c1.2-.69,2.35-1.18,3.34-1.66s1.85-.84,2.57-1.11l1.66-.63A2.53,2.53,0,0,1,131,349.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.46,365.89a3.92,3.92,0,0,1,1.35-2,8.49,8.49,0,0,1,5.43-2.08,15,15,0,0,1,5.71,1.11,8.65,8.65,0,0,1,2.16,1,12.86,12.86,0,0,1-2.29-.67,17.2,17.2,0,0,0-5.57-.93,8.91,8.91,0,0,0-5.18,1.82A16,16,0,0,0,106.46,365.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8,369.66a20.27,20.27,0,0,0,1.54-5c.36-2.9-.52-5.19-.34-5.24a3.38,3.38,0,0,1,.63,1.47,10.09,10.09,0,0,1,.27,3.84,10.32,10.32,0,0,1-1.14,3.67C103.28,369.26,102.85,369.7,102.8,369.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.91,420.5c.84,15,5.35,30.22,12.3,45.62H105.4C112,450.87,116.23,435.66,117,420.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.08,444.75c0,.15-9.94.28-22.2.28s-22.21-.13-22.21-.28,9.94-.29,22.21-.29S112.08,444.59,112.08,444.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41,450.17c0,.16-9.32.29-20.82.29s-20.81-.13-20.81-.29,9.31-.28,20.81-.28S111.41,450,111.41,450.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,430.34a86.52,86.52,0,0,1,0,13.91,83.55,83.55,0,0,1,0-13.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87,430.34a89.65,89.65,0,0,1,0,14.41,92.84,92.84,0,0,1,0-14.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06,430.22a93.16,93.16,0,0,1,0,14.69,96.48,96.48,0,0,1,0-14.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,430.34c0,.16-11.66.28-26,.28s-26.05-.12-26.05-.28,11.66-.28,26.05-.28S116,430.18,116,430.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,438.12l3,28.34h-8.79L438.58,438Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.08,437.77l3,28.41h-8.78l-11.45-28.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.1,262.87c-4.75-7.27-99.88-9.18-104-1.69l-35.35,65.75-52.25-2.88s-7-.39-14,6.12c-3.42,3.22-3.43,23.68-2.54,31.59.59,5.27,8,76.93,8,76.93l197,1.37S465.86,270.14,461.1,262.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.59,439.49s0-.22,0-.63,0-1.05,0-1.85c0-1.64-.06-4-.11-7.07-.07-6.15-.18-15-.31-25.82l.16.16-59.81-.11-62-.21.16-.14A101.67,101.67,0,0,0,278.31,428c.19,2.86.44,5.08.63,6.59.09.74.17,1.31.22,1.71s.06.59.06.59a80,80,0,0,1-1.08-8.88,99.27,99.27,0,0,1,1.18-24.22l0-.13h.13l62,.11,59.82.2h.16v.17c.07,10.83.12,19.67.16,25.82,0,3.05,0,5.43,0,7.07v1.85C401.6,439.27,401.59,439.49,401.59,439.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.54,328.58h.4a7,7,0,0,1,1.18.07,12.06,12.06,0,0,1,4.36,1.4,16.42,16.42,0,0,1,5.45,4.9,22,22,0,0,1,3.65,9.16,62.63,62.63,0,0,1,.69,12.18c0,4.42-.23,9.19-.57,14.25-.68,10.13-2,21.42-3.5,33.6l0,.17H408l-49.81-.11-90.33-.28h-.14v-.14a80.17,80.17,0,0,1,1-17.94c1-5.21,2.58-9.6,4.79-12.65a13.06,13.06,0,0,1,3.53-3.46l.44-.3.46-.23.85-.43c.58-.19,1.09-.41,1.57-.52l1.27-.26c.37,0,.69-.05.94-.07l.76,0-.76.09c-.25,0-.56,0-.93.09l-1.26.27c-.47.12-1,.34-1.55.54l-.84.44-.44.23-.43.3a12.89,12.89,0,0,0-3.48,3.45c-2.16,3-3.74,7.4-4.68,12.59a80,80,0,0,0-1,17.88l-.16-.15,90.33.17,49.81.14-.2.17c1.48-12.18,2.86-23.46,3.56-33.57.36-5.06.56-9.82.62-14.24a63.88,63.88,0,0,0-.64-12.13,21.94,21.94,0,0,0-3.57-9.09,16.45,16.45,0,0,0-5.36-4.9,12.24,12.24,0,0,0-4.31-1.45C397.08,328.57,396.54,328.61,396.54,328.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.39 436.77 260.27 466.46 269.05 466.46 280.31 436.89 263.39 436.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.61,261.25l-.26.21a7.51,7.51,0,0,0-.71.67,5.92,5.92,0,0,0-1.52,3.36c-.51,3.27-1.25,8-2.17,13.86-1.87,11.77-4.48,28.15-7.42,46.65l0,.18h-.19l-9.7-.49c-10.5-.48-20.5-.85-29.6-.87-2.27,0-4.49,0-6.64.12l-1.6.09c-.52,0-1,.1-1.56.15a5.44,5.44,0,0,0-2.81,1,18.15,18.15,0,0,0-4.08,4.08,45.91,45.91,0,0,0-3,4.48,83.65,83.65,0,0,0-6.83,14.75,32.09,32.09,0,0,0-1.2,4.25,9.39,9.39,0,0,0-.16,1.14c0,.26,0,.39,0,.39a3.85,3.85,0,0,1,0-.39,9.72,9.72,0,0,1,.12-1.15,28.63,28.63,0,0,1,1.14-4.29c.6-1.84,1.43-4,2.53-6.55a79,79,0,0,1,4.19-8.3,46.35,46.35,0,0,1,3-4.52,18.27,18.27,0,0,1,4.15-4.18l.67-.4c.23-.12.48-.21.73-.31s.51-.14.77-.22.52-.06.79-.09c.52-.05,1.05-.13,1.58-.16l1.61-.09c2.15-.11,4.38-.14,6.65-.15,9.11,0,19.12.36,29.62.84l9.71.5-.22.17c3-18.49,5.65-34.86,7.56-46.62L455,265.47a6,6,0,0,1,1.61-3.39A4.73,4.73,0,0,1,457.61,261.25Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.19,465.56c0,.14-91.88.26-205.18.26s-205.2-.12-205.2-.26,91.86-.26,205.2-.26S454.19,465.42,454.19,465.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 288.42,
    cy: 92.52,
    r: 59.51,
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 288.42,
    cy: 92.52,
    r: 59.51
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 283.61,
    cy: 87.12,
    r: 59.51,
    transform: "translate(183.55 366.43) rotate(-87.37)",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.17,
    cy: 86.6,
    rx: 45.34,
    ry: 44.22,
    transform: "translate(-12.95 87.52) rotate(-17.18)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.18,128.67A45.32,45.32,0,0,1,239.9,100c.12.42.22.83.35,1.25a45.33,45.33,0,0,0,86.61-26.78c-.13-.41-.28-.82-.42-1.23A45.31,45.31,0,0,1,296.18,128.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.17,44.54a45.3,45.3,0,0,1,56.27,28.68c-.11-.41-.22-.83-.35-1.24a45.32,45.32,0,1,0-86.6,26.78c.13.41.27.82.41,1.22A45.31,45.31,0,0,1,270.17,44.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,92c-1.88-6.08-6-9.13-10.77-9.41,2.48-2.89,3.43-7.06,1.94-11.88-1.85-6-6.49-9.19-13.23-8.66l-2.28-7.38-6.82,2.11,2.12,6.86-3.87,1.2-2.12-6.86L267.71,60l2.13,6.86-6.21,1.92-4.33,1.34L261.41,77l4.32-1.34L276,108.77l-4.78,1.48,2.11,6.82,4.78-1.48h0l6.21-1.92,2.47,8,6.81-2.11-2.46-8,3.86-1.19,2.47,8,6.82-2.11L301.72,108C309.08,104.54,311.7,98.88,309.56,92ZM274.37,73l9.23-2.86c5.12-1.58,8.69-.34,10,4s-.92,7.31-6,8.89l-10.47,3.24-4-12.9Zm21,29.83-11.16,3.45-.79.25L279.21,93l12-3.7c5.57-1.72,9.23-.58,10.68,4.1S300.91,101.07,295.33,102.79Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.56,92c-1.88-6.08-6-9.13-10.77-9.41,2.48-2.89,3.43-7.06,1.94-11.88-1.85-6-6.49-9.19-13.23-8.66l-2.28-7.38-6.82,2.11,2.12,6.86-3.87,1.2-2.12-6.86L267.71,60l2.13,6.86-6.21,1.92-4.33,1.34L261.41,77l4.32-1.34L276,108.77l-4.78,1.48,2.11,6.82,4.78-1.48h0l6.21-1.92,2.47,8,6.81-2.11-2.46-8,3.86-1.19,2.47,8,6.82-2.11L301.72,108C309.08,104.54,311.7,98.88,309.56,92ZM274.37,73l9.23-2.86c5.12-1.58,8.69-.34,10,4s-.92,7.31-6,8.89l-10.47,3.24-4-12.9Zm21,29.83-11.16,3.45-.79.25L279.21,93l12-3.7c5.57-1.72,9.23-.58,10.68,4.1S300.91,101.07,295.33,102.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.25,93c-1.88-6.08-6-9.12-10.77-9.41,2.48-2.89,3.43-7.06,1.94-11.87-1.85-6-6.49-9.19-13.23-8.66l-2.29-7.38-6.81,2.1,2.12,6.86-3.87,1.2L271.22,59l-6.82,2.11,2.12,6.86-6.2,1.92L256,71.17,258.1,78l4.32-1.34,10.25,33.15-4.78,1.48,2.11,6.81,4.78-1.48h0l6.21-1.92,2.47,8,6.81-2.1-2.47-8,3.87-1.2,2.47,8,6.82-2.11L298.41,109C305.76,105.57,308.39,99.9,306.25,93ZM271.06,74l9.23-2.85c5.12-1.59,8.69-.34,10,4s-.92,7.31-6,8.89l-10.47,3.24-4-12.89Zm21,29.84-11.16,3.45-.79.24L275.9,94l12-3.69c5.57-1.73,9.23-.59,10.67,4.09S297.6,102.09,292,103.82Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.13,51.2c-.12.09-1.68-2-5-5.35a59.55,59.55,0,0,0-44.58-17.47,58.39,58.39,0,0,0-17,3.19,59.23,59.23,0,0,0-8.38,3.65,58.74,58.74,0,0,0-15,11.34,59.24,59.24,0,0,0-5.8,7.08,57.45,57.45,0,0,0-4.49,7.61,56.74,56.74,0,0,0-3.18,7.86,59.65,59.65,0,0,0-2.85,15.39,60,60,0,0,0,7.56,32.26c2.31,4.11,3.92,6.18,3.79,6.27a7.81,7.81,0,0,1-1.23-1.45c-.4-.49-.86-1.1-1.37-1.86s-1.12-1.62-1.71-2.65a57.8,57.8,0,0,1-7.25-18.73,61.13,61.13,0,0,1-1.09-13.9,60.29,60.29,0,0,1,2.78-15.77,56.93,56.93,0,0,1,3.21-8.07,58.64,58.64,0,0,1,4.57-7.83,60.51,60.51,0,0,1,5.93-7.28,59.56,59.56,0,0,1,15.38-11.64,58.6,58.6,0,0,1,8.62-3.73,59.87,59.87,0,0,1,17.41-3.18,59.51,59.51,0,0,1,29,6.43,57.6,57.6,0,0,1,16.06,12.05c.83.85,1.5,1.67,2.08,2.37s1.07,1.31,1.43,1.82A7.8,7.8,0,0,1,331.13,51.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,59c.08.26-2.54,1.31-6.63,2.72l.43-.8c.68,2,1.45,4.28,2.25,6.82l.23.74-.75.23-1.83.57c-3.22,1-6.23,1.88-8.74,2.56l.43-.81c1.14,4.16,1.75,6.93,1.49,7s-1.32-2.55-2.73-6.62l-.2-.6.63-.21c2.45-.85,5.43-1.82,8.66-2.82l1.84-.56-.52,1c-.77-2.55-1.45-4.91-2-6.9l-.18-.65.6-.16C268.39,59.3,271.14,58.69,271.22,59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37,55.32c.13.41-1.61,1.32-3.89,2s-4.22.94-4.35.53,1.62-1.32,3.89-2S283.25,54.91,283.37,55.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.17,109.43c-.41.13-3-7.05-5.77-16s-4.69-16.35-4.28-16.48,3,7,5.77,16S272.58,109.3,272.17,109.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.75,83c.13.41-2.72,1.65-6.35,2.78s-6.67,1.7-6.8,1.28,2.71-1.65,6.34-2.78S287.62,82.61,287.75,83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,103.18c.13.41-2.71,1.65-6.34,2.78s-6.68,1.7-6.81,1.28,2.71-1.65,6.34-2.78S294.13,102.77,294.26,103.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.28,152a24.93,24.93,0,0,1-4.73-5.38,24.93,24.93,0,0,1,4.73,5.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.06,150.94a23.29,23.29,0,0,1-4.54-5.16,12,12,0,0,1,2.47,2.41A11.76,11.76,0,0,1,278.06,150.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4,148.54a11.47,11.47,0,0,1-2.46-2.41,11.87,11.87,0,0,1-2.08-2.75,11.42,11.42,0,0,1,2.47,2.41A11.76,11.76,0,0,1,268.4,148.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.67,151.18a12.63,12.63,0,0,1-2.56-2.52,12.35,12.35,0,0,1-2.17-2.86,12.34,12.34,0,0,1,2.56,2.52A12.59,12.59,0,0,1,298.67,151.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,148.73a12.24,12.24,0,0,1-2.57-2.52,12.63,12.63,0,0,1-2.17-2.87,25.72,25.72,0,0,1,4.74,5.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.79,144.81a12.34,12.34,0,0,1-2.56-2.52,12.59,12.59,0,0,1-2.17-2.86,12.63,12.63,0,0,1,2.56,2.52A12.35,12.35,0,0,1,316.79,144.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,140a13.32,13.32,0,0,1-2.56-2.52,12.28,12.28,0,0,1-2.17-2.87,12.67,12.67,0,0,1,2.56,2.52A12.28,12.28,0,0,1,324.6,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.71,133.58a12.56,12.56,0,0,1-2.57-2.52,12.28,12.28,0,0,1-2.17-2.87,12.71,12.71,0,0,1,2.56,2.52A12.87,12.87,0,0,1,331.71,133.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.53,126.34a12.71,12.71,0,0,1-2.56-2.52,12.87,12.87,0,0,1-2.18-2.87,12.56,12.56,0,0,1,2.57,2.52A12.28,12.28,0,0,1,337.53,126.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,119.12a12.07,12.07,0,0,1-2.56-2.52,13.22,13.22,0,0,1-2.18-2.86,12.24,12.24,0,0,1,2.57,2.52A12.59,12.59,0,0,1,341.82,119.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41,111a12.63,12.63,0,0,1-2.56-2.52,12.59,12.59,0,0,1-2.17-2.86,12.34,12.34,0,0,1,2.56,2.52A12.35,12.35,0,0,1,345.41,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.86,102.18a12.63,12.63,0,0,1-2.56-2.52,12.59,12.59,0,0,1-2.17-2.86,12.34,12.34,0,0,1,2.56,2.52A12.59,12.59,0,0,1,347.86,102.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.65,92.67a12.71,12.71,0,0,1-2.56-2.52,12.87,12.87,0,0,1-2.18-2.87,12.9,12.9,0,0,1,2.57,2.52A12.63,12.63,0,0,1,348.65,92.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,82.9a18.09,18.09,0,0,1-3.07-3.1,19,19,0,0,1-2.69-3.45,18.85,18.85,0,0,1,3.08,3.1A18.45,18.45,0,0,1,347.9,82.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.83,69.76a18.55,18.55,0,0,1-3.07-3.1,19,19,0,0,1-2.69-3.45,18.85,18.85,0,0,1,3.08,3.1A18.09,18.09,0,0,1,343.83,69.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.57,103.24a.89.89,0,0,0,.16.77.82.82,0,0,0,.86.26.82.82,0,0,0,.56-.7.86.86,0,0,0-.31-.72c-.38-.31-.77-.19-.77-.26S256.72,102.77,256.57,103.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,77.52a.83.83,0,0,0,.15.76.8.8,0,0,0,1.42-.43.78.78,0,0,0,0-.27h0a.89.89,0,0,0-.27-.44c-.39-.31-.77-.19-.78-.26S281,77.05,280.9,77.52Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24,131.65a.89.89,0,0,0,.16.77.82.82,0,0,0,.86.26.82.82,0,0,0,.56-.7.86.86,0,0,0-.31-.72c-.39-.31-.77-.19-.77-.26S257.39,131.18,257.24,131.65Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.82,71.74a.87.87,0,0,0,.16.76.8.8,0,0,0,1.42-.44.86.86,0,0,0-.31-.72c-.39-.31-.77-.19-.77-.26S316,71.26,315.82,71.74Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,58.75a.87.87,0,0,0,.16.76.8.8,0,0,0,.86.27.82.82,0,0,0,.56-.7.86.86,0,0,0-.31-.72,1,1,0,0,0-.61-.23l0,.12a1.84,1.84,0,0,1,.11.52,3.17,3.17,0,0,1-.19-.49l-.06-.16s-.06,0-.06,0S251.75,58.28,251.6,58.75Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.25,60.47a.83.83,0,0,0,.15.76.8.8,0,0,0,1.42-.44.83.83,0,0,0-.3-.71c-.39-.31-.77-.19-.78-.26S316.4,60,316.25,60.47Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,82.1a.83.83,0,0,0,.16.77.82.82,0,0,0,.86.26.82.82,0,0,0,.56-.7.85.85,0,0,0-.22-.63h0c-.16,0-.24,0-.24,0a1.35,1.35,0,0,1,.22-.09l-.05-.05c-.39-.31-.77-.19-.77-.26S280.05,81.63,279.9,82.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32,96.82a.83.83,0,0,0,.15.76.81.81,0,0,0,.86.27.79.79,0,0,0,.56-.7,1.08,1.08,0,0,0,0-.18s-.06,0-.06,0l.05,0a.82.82,0,0,0-.29-.51c-.39-.31-.77-.19-.78-.26S275.47,96.35,275.32,96.82Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,75.82l46.36-14.38L297,67.32l.05,0,.06,0,14-4.44,3.76-1.21,1-.32.19-.07a.48.48,0,0,0,.08.16,1.16,1.16,0,0,0,2.1-.65,1.1,1.1,0,0,0-.51-1,1,1,0,0,0-.71-.14c-.17,0-.24.1-.24.12s.39,0,.78.26a.83.83,0,0,1,.3.71.8.8,0,0,1-1.42.44.83.83,0,0,1-.15-.76c.15-.48.53-.59.49-.65s-.1,0-.26,0a1,1,0,0,0-.5.52,1.11,1.11,0,0,0,0,.91l-.18,0-1,.29-3.78,1.14-14,4.29-8.5-5.92-.06-.05-.08,0L242,75.43l-17.53,5.42c0,.15,0,.29,0,.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,49.4l9,6.09.07,0,.08,0,8.93-2.83-.14-.19-8.81,2.66-9-6.14-.08,0-.1,0-5.83,1.8L286.6,57.52l-6.53,2.09-1.77.59a3,3,0,0,0-.6.23,4.86,4.86,0,0,0,.63-.15l1.79-.52,6.56-2,21.62-6.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.69,85.61l5,1h.06l7.66-2.32,2-.64.14,0a.59.59,0,1,0,.38-.77.61.61,0,0,0-.4.71l-.14,0-2,.57-7.66,2.2-5-1h-.07l-32.58,10-11.41,3.53-2.5-.64c0,.14,0,.28.08.42l2.37.62.06,0,.05,0,11.47-3.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.34,81.76l-4.65-.44h0l0,0-2.74.86c-.53-1.76-1-3.44-1.5-5l-.05-.18-.17.06L253.62,81.1l-3.49,1.16-.39.13a.57.57,0,0,0-.71-.34.59.59,0,1,0,.35,1.13.57.57,0,0,0,.39-.7l.39-.12,3.53-1.07,12.39-3.86q.71,2.4,1.47,5.06l.06.19.18-.06,2.9-.9,4.65.45h0l0,0,5.34-1.64,24-7.49,5.06,1.55h.07l4.5-1.44,1.19-.4.06,0h0a1.17,1.17,0,0,0,2.11-.65,1.12,1.12,0,0,0-.52-1,1,1,0,0,0-.71-.15c-.17,0-.24.1-.23.12s.38,0,.77.26a.86.86,0,0,1,.31.72.8.8,0,0,1-1.42.44.87.87,0,0,1-.16-.76c.15-.48.53-.6.5-.66s-.11,0-.26,0a1,1,0,0,0-.51.52,1.11,1.11,0,0,0,.09,1l-.05,0-1.2.34-4.5,1.33-5.06-1.62,0,0-.05,0-24.1,7.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.68,131a1,1,0,0,0-.71-.14c-.17,0-.24.1-.23.12s.38-.05.77.26a.86.86,0,0,1,.31.72.82.82,0,0,1-.56.7.82.82,0,0,1-.86-.26.89.89,0,0,1-.16-.77c.15-.47.53-.59.5-.65s-.11,0-.26,0a1,1,0,0,0-.51.52,1.12,1.12,0,0,0,.12,1.09,1.17,1.17,0,0,0,2.11-.65s0,0,0,0l.17,0,.86-.24,3.21-.93,11.24-3.4.1,0,0-.11c.58-2.38,1.21-5,1.86-7.66l0-.05,0-.06-1-3.17c-1.44-4.63-2.8-9-3.95-12.7l0-.08-.08,0L265.39,101h-.09l-5.24,1.69-1.4.47-.19.07a1.15,1.15,0,0,0-.46-.6,1,1,0,0,0-.71-.14c-.17,0-.24.1-.23.12s.39,0,.77.26a.86.86,0,0,1,.31.72.82.82,0,0,1-.56.7.82.82,0,0,1-.86-.26.89.89,0,0,1-.16-.77c.15-.47.53-.59.5-.65s-.1,0-.26,0a1,1,0,0,0-.51.52,1.12,1.12,0,0,0,.12,1.09,1.17,1.17,0,0,0,2.11-.65,1,1,0,0,0,0-.31l.19,0,1.43-.41,5.22-1.55,6.07,2.49c1.14,3.71,2.46,8,3.87,12.63l1,3.12L274.45,127l-11.09,3.51-3.17,1-.84.29-.16.06A1.1,1.1,0,0,0,258.68,131Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,101.65a.59.59,0,0,0,.4-.7h0l1.67-.48,6.15-1.84h0l0,0,5.44-6.77,13-4c0-.15,0-.29,0-.44L330,91.48l-.06,0,0,0-5.39,6.84-6.07,1.94-1.65.55h0a.6.6,0,0,0-.73-.36.59.59,0,0,0-.39.74A.58.58,0,0,0,316.37,101.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.86,145.51c-.06-.2-.12-.45-.21-.76l-1-3.48c-.86-2.93-2.09-7-3.47-11.43-.43-1.4-.85-2.75-1.25-4l0-.08-.07,0L280,121.63c-.35-1.06-.64-1.93-.87-2.6-.15-.45-.26-.74-.31-.86a.82.82,0,0,0,.22,0,.61.61,0,1,0-.27,0c0,.13.1.43.23.91.2.69.46,1.59.77,2.69v0l.05,0,7.75,4.17,1.22,4c1.38,4.46,2.65,8.48,3.58,11.4.47,1.4.85,2.56,1.14,3.44.1.3.19.55.26.74a.63.63,0,0,0-.31.27l.92-.16A.59.59,0,0,0,293.86,145.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,65.13a.6.6,0,1,0,.39-.74A.6.6,0,0,0,249.09,65.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,108.52l1.14-.36.2-.07a.49.49,0,0,0,0,.12.62.62,0,1,0,0-.17l-.21,0-1.16.3-4.28,1.16-14.36,4c-.53-1.58-1.08-3.22-1.65-4.9l-.45-1.35c1.42-2.41,2.79-4.71,4-6.82l0-.07,0-.08c-.58-1.83-1.12-3.56-1.61-5.12l0-.07-.06,0-2-1.06-.06,0h-.06l-6.47,2.08-1.76.59-.22.07a1.07,1.07,0,0,0-.46-.62,1,1,0,0,0-.71-.14c-.17,0-.24.1-.24.12s.39,0,.78.26a.82.82,0,0,1,.29.51l-.05,0s0,0,.06,0a1.08,1.08,0,0,1,0,.18.79.79,0,0,1-.56.7.81.81,0,0,1-.86-.27.83.83,0,0,1-.15-.76c.15-.47.53-.59.49-.65s-.1,0-.26,0a1,1,0,0,0-.5.52,1.1,1.1,0,0,0,.12,1.09,1.16,1.16,0,0,0,2.1-.65.86.86,0,0,0,0-.28l.22-.06,1.79-.51,6.45-1.92,1.9,1c.47,1.53,1,3.21,1.52,5l-4.07,6.81,0,.08,0,.09c.15.46.32,1,.48,1.45.59,1.74,1.17,3.43,1.72,5.07l.06.19.19-.06L302,109.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.16,108.47c-1.1-3.74-2.25-7.68-3.42-11.67-.17-.55-.33-1.1-.49-1.65l0-.08-.08,0-6.6-3.68-.07,0-.09,0-33.95,10.52h0l0,0-18.14,18.46a1.88,1.88,0,0,1,.16.23l18.2-18.4,33.84-10.44,6.45,3.59c.15.53.31,1,.46,1.57,1.2,4.07,2.37,8.07,3.49,11.87l.06.2.19-.06,45.48-13.56c0-.11,0-.22,0-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.9,87.12c.37,1.12.88,2.7,1.53,4.69v0l.05,0,11.43,5.61.07,0,.07,0,12.82-4L340,86.64l3.08-1c0-.08,0-.16,0-.24l-3.15,1-22.2,6.8-12.74,4-11.37-5.44L292,87.08l-.45-1.23a2,2,0,0,0-.18-.41,2.79,2.79,0,0,0,.11.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.92,69.75l-.05,0,0,0-2.91,3.09-10.45,3.31-3,1c-.29.09-.52.18-.72.25a1.11,1.11,0,0,0-.43-.55,1,1,0,0,0-.71-.14c-.17,0-.25.1-.24.12s.39-.05.78.26a.89.89,0,0,1,.27.44h0a.78.78,0,0,1,0,.27.8.8,0,0,1-1.42.43.83.83,0,0,1-.15-.76c.14-.47.53-.59.49-.65s-.1,0-.26,0a1,1,0,0,0-.5.52,1.1,1.1,0,0,0,.12,1.09,1.16,1.16,0,0,0,2.1-.65,1,1,0,0,0-.05-.36l.72-.2,3-.88,10.54-3.18h.05l0,0,2.92-3.07,5.59-1.61,17.26-5.06,5.21-1.58,1.35-.43A.59.59,0,0,0,330.6,61a.59.59,0,0,0-1.14.33l-1.36.36-5.26,1.45-17.29,4.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,134.09c-.49-1.59-1-3.13-1.43-4.6l0-.09-.09,0-4.1-1.52-.06,0-.06,0-8.17,2.6-2.3.77-.27.09a.59.59,0,0,0-.72-.35.6.6,0,0,0-.39.75.59.59,0,0,0,.74.39.58.58,0,0,0,.4-.69l.27-.08,2.34-.67,8.15-2.44,3.94,1.49c.44,1.45.91,3,1.39,4.51l3.88,12.37.31,0C285.67,143.1,284.35,138.79,282.92,134.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.55,142.68l0-.08,0-.08c-1.89-6.1-3.68-11.85-5.24-16.88l0-.07-.06,0-6-3.12c-1.36-4.31-2.47-7.82-3.26-10.3l-.92-2.84c-.1-.29-.18-.52-.24-.71H275a.6.6,0,0,0,.39-.75.59.59,0,0,0-1.13.35.58.58,0,0,0,.57.41c0,.2.12.44.2.74.2.69.48,1.65.84,2.86.76,2.5,1.83,6.06,3.15,10.41v.06l.06,0,5.94,3.16,5.15,16.74-.42.8-1.64,3.11.49,0,1.52-2.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.69,105.93l-28.54,8.76-6.25,1.94-.13,0v.14c-.17,2.77-.34,5.43-.49,8v.07c2,6.37,3.75,12,5.13,16.38l.24-.11c-1.35-4.4-3.06-10-5-16.35.16-2.47.32-5.08.49-7.79l6.12-1.88,28.5-8.88,1.35-.43c0-.1.07-.21.11-.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.22,90.08l0,.09.09,0,2.36,1,6.62,2.9.07,0,.07,0L321,89.59l4.22-1.37,1-.32a.58.58,0,0,0,.72.35.59.59,0,1,0-.35-1.13.58.58,0,0,0-.39.7l-1,.27-4.26,1.26-14.5,4.41-6.55-2.89-2.28-1-3.74-12-.05-.17-.17.06-9.18,2.91-2.56.84-.34.12a1.57,1.57,0,0,0-.21-.17,1,1,0,0,0-.71-.14c-.17,0-.24.1-.23.12s.38,0,.77.26l.05.05a1.35,1.35,0,0,0-.22.09s.08,0,.24,0h0a.85.85,0,0,1,.22.63.82.82,0,0,1-.56.7.82.82,0,0,1-.86-.26.83.83,0,0,1-.16-.77c.15-.47.53-.59.5-.65s-.11,0-.27,0a1,1,0,0,0-.5.52,1.14,1.14,0,0,0,.12,1.1,1.17,1.17,0,0,0,2.11-.65,1.18,1.18,0,0,0-.26-.74l.32-.09,2.59-.75,9.06-2.72C294.64,81.66,295.89,85.71,297.22,90.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,72.86l-6.45-3.41-.08,0-.08,0-.48.15-23.36,7.26-4.25-1.37-.05,0,0,0L300.58,77l-.06,0,0,0c-1.49,2.86-2.73,5.25-3.68,7.09l0,0v0q.75,2.36,1.17,3.63l.31.92a1.41,1.41,0,0,0,.12.31s0-.11-.08-.32-.15-.55-.26-.94L297,84.2c1-1.82,2.22-4.16,3.73-7l4.72-1.44,4.24,1.4.06,0,.05,0L333.22,70l.4-.13,6.46,3.41.07,0,.08,0,1.17-.36c0-.13-.06-.26-.1-.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.19,39.46l.08,0h0l6.82,3.59c1.75,5.57,3.31,10.56,4.56,14.56l0,.08.08,0,6,1.55h.05l3.26-1.06.84-.29a1,1,0,0,0,.28-.11,1.18,1.18,0,0,0-.3.06l-.85.24-3.26,1-5.83-1.62c-1.23-4-2.75-9-4.46-14.59l0-.08-.08,0-6.83-3.61-1.06-3.38-.35.21,1,3.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.73,41.8l0,.07,0,.07c1.25,3.93,2.31,7.29,3.09,9.72.37,1.15.68,2.08.91,2.78a7.25,7.25,0,0,0,.37,1,6.78,6.78,0,0,0-.25-1c-.21-.7-.48-1.64-.81-2.8-.74-2.44-1.74-5.78-2.92-9.7,1.25-2.37,2.63-5,4.07-7.68l2.18-4.15,0-.07,0-.08c-.11-.33-.21-.65-.31-1l-.38.08c.09.31.18.61.28.93q-1.05,2-2.15,4.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.36,40.18a.58.58,0,0,0-.72-.76.59.59,0,0,0-.4.74.6.6,0,0,0,.75.39.62.62,0,0,0,.3-.23c.18.12.42.26.7.42.75.43,1.82,1,3.08,1.7l.8,2.66c.64,2.07,1.25,3.94,1.7,5.29a13.7,13.7,0,0,0,.82,2.15,13.76,13.76,0,0,0-.54-2.24c-.38-1.37-.94-3.25-1.58-5.32-.3-1-.59-1.87-.86-2.72l0-.08-.07,0c-1.3-.67-2.42-1.23-3.22-1.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,53.82l0,.06.05,0,3.68,2.53.08,0,.09,0,17.37-5.35,8.95-2.78.08,0,0-.08,5.06-10.55-.32-.22L311.35,48l-8.87,2.74-17.26,5.35-3.56-2.43-7.84-25.1,0-.11-.23,0,0,.15C275.5,34.81,278.18,43.55,281.32,53.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,58.6l-4.13,1.21L272.29,64l-.56-1.83-.05-.14,0-.11-.1,0-6.05-2-.06,0-.06,0-10.89,3.45-3.15,1-.83.29c-.19.07-.29.11-.28.12a1.4,1.4,0,0,0,.3,0l.85-.24,3.18-.92,10.88-3.28,5.88,1.91v0l.63,2,.06.2.2-.07L286,60.08l4.1-1.33,1.1-.38a1.37,1.37,0,0,0,.37-.16l-.4.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65,51.89l4.47,2.93.08,0,.09,0,9.8-3.08,1.65,5.1.4,1.19s0,0,0,.05,0,0,.06,0l.06.16a3.17,3.17,0,0,0,.19.49,1.84,1.84,0,0,0-.11-.52l0-.12a1,1,0,0,1,.61.23.86.86,0,0,1,.31.72.82.82,0,0,1-.56.7.8.8,0,0,1-.86-.27.87.87,0,0,1-.16-.76c.15-.47.53-.59.5-.65s-.11,0-.26,0a1,1,0,0,0-.51.52,1.12,1.12,0,0,0,.12,1.09,1.17,1.17,0,0,0,2.11-.65,1.13,1.13,0,0,0-.52-1,1,1,0,0,0-.71-.14l-.1,0c-.09-.33-.2-.73-.34-1.2-.38-1.3-.91-3.09-1.56-5.28l0-.15-.15,0-9.88,3-4.36-2.87Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.18,86.31H261.48a18.7,18.7,0,0,1,18.7,18.7V399.19a16.68,16.68,0,0,1-16.68,16.68H132.18a18.42,18.42,0,0,1-18.42-18.42V104.74A18.42,18.42,0,0,1,132.18,86.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.81,
    y: 170.5,
    width: 324.31,
    height: 161.18,
    rx: 15.83,
    transform: "translate(448.06 54.12) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,99.32a1.85,1.85,0,0,1,0-3.7h23.8a1.85,1.85,0,1,1,0,3.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26,99.32a1.85,1.85,0,1,1,1.85-1.85A1.85,1.85,0,0,1,172.26,99.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.07,99.32a1.85,1.85,0,1,1,1.85-1.85A1.85,1.85,0,0,1,179.07,99.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.69,99.32a1.85,1.85,0,1,1,1.85-1.85A1.85,1.85,0,0,1,221.69,99.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.87,99.32a1.85,1.85,0,1,1,1.85-1.85A1.85,1.85,0,0,1,214.87,99.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,157.94h0a0,0,0,0,1,0,0v37.88a0,0,0,0,1,0,0h0a1.07,1.07,0,0,1-1.07-1.07V159A1.07,1.07,0,0,1,281.24,157.94Z",
    transform: "translate(561.45 353.76) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,181.29h.06a0,0,0,0,1,0,0v24a0,0,0,0,1,0,0h-.06a1.07,1.07,0,0,1-1.07-1.07V182.35A1.07,1.07,0,0,1,113.69,181.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,150h.06a0,0,0,0,1,0,0v24a0,0,0,0,1,0,0h-.06a1.07,1.07,0,0,1-1.07-1.07V151A1.07,1.07,0,0,1,113.69,150Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,126.44h0a0,0,0,0,1,0,0v11.15a0,0,0,0,1,0,0h0a.95.95,0,0,1-.95-.95v-9.26A.95.95,0,0,1,113.73,126.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,91.73H234.43a4.87,4.87,0,0,0-4.69,3.52l-1.84,6.31a5.46,5.46,0,0,1-5.25,4H173a5.48,5.48,0,0,1-5.26-4l-1.83-6.31a4.88,4.88,0,0,0-4.69-3.52H131.61A10.62,10.62,0,0,0,121,102.34v295a12.05,12.05,0,0,0,12.06,12.05h131a10.59,10.59,0,0,0,10.59-10.59V103.16A11.43,11.43,0,0,0,263.24,91.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.99,
    y: 270.96,
    width: 153.68,
    height: 37.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.99,
    y: 342.85,
    width: 153.68,
    height: 37.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.02,
    y: 171.02,
    width: 126.17,
    height: 88.39,
    rx: 17.17,
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.02,
    y: 171.02,
    width: 126.17,
    height: 88.39,
    rx: 17.17,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 130.45,
    y: 157.32,
    width: 136.89,
    height: 95.9,
    rx: 9.33,
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35,299.13h0a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8h0A8,8,0,0,1,140.35,299.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.12 290.5 140.35 285.99 143.23 290.61 140.14 289.5 137.12 290.5",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.99 291.23 140.18 293.01 143.31 291.36 140.18 289.99 136.99 291.23",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,292c.08.06,3.19,4.09,3.19,4.09l3.13-4.09-3.13,1.69Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,332.39h0a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8h0A8,8,0,0,1,141.34,332.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,367.89h0a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8h0A8,8,0,0,1,141.34,367.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.36,292c0,.15-5.25.26-11.71.26S155,292.1,155,292s5.24-.26,11.7-.26S178.36,291.81,178.36,292Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.61,296.11c0,.14-11.08.26-24.75.26s-24.76-.12-24.76-.26,11.08-.26,24.76-.26S204.61,296,204.61,296.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.11,324c0,.15-5.24.27-11.7.27s-11.71-.12-11.71-.27,5.24-.26,11.71-.26S180.11,323.85,180.11,324Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.37,328.15c0,.14-11.08.26-24.76.26s-24.76-.12-24.76-.26,11.09-.26,24.76-.26S206.37,328,206.37,328.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182,359.4c0,.14-5.25.26-11.71.26s-11.7-.12-11.7-.26,5.24-.26,11.7-.26S182,359.26,182,359.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.2,363.56c0,.14-11.08.26-24.75.26s-24.76-.12-24.76-.26,11.08-.26,24.76-.26S208.2,363.41,208.2,363.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8,320.36l-1,4.1a1.16,1.16,0,0,0-.93.75,1.62,1.62,0,0,0-.17,1l.61-.26-.44,2.25h6.23l.46-1.76h-3.74l.31-1.64a1.65,1.65,0,0,0,1.1-1.53l-.69.11.75-3Z",
    style: {
      fill: "#E59B40"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.85,223.08c-.14,0-.26-10.7-.26-23.89s.12-23.88.26-23.88.26,10.69.26,23.88S141,223.08,140.85,223.08Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.74,223.08c-.15,0-.26-10.7-.26-23.89s.11-23.88.26-23.88S156,186,156,199.19,155.88,223.08,155.74,223.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.63,223.08c-.15,0-.26-10.7-.26-23.89s.11-23.88.26-23.88.26,10.69.26,23.88S170.77,223.08,170.63,223.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.51,223.08c-.14,0-.26-10.7-.26-23.89s.12-23.88.26-23.88.26,10.69.26,23.88S185.66,223.08,185.51,223.08Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200.4,223.08c-.14,0-.26-10.7-.26-23.89s.12-23.88.26-23.88.26,10.69.26,23.88S200.55,223.08,200.4,223.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.29,223.08c-.14,0-.26-10.7-.26-23.89s.12-23.88.26-23.88.26,10.69.26,23.88S215.43,223.08,215.29,223.08Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M230.18,223.08c-.15,0-.26-10.7-.26-23.89s.11-23.88.26-23.88.26,10.69.26,23.88S230.32,223.08,230.18,223.08Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.07,223.08c-.15,0-.26-10.7-.26-23.89s.11-23.88.26-23.88.26,10.69.26,23.88S245.21,223.08,245.07,223.08Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260,223.08c-.14,0-.26-10.7-.26-23.89s.12-23.88.26-23.88.26,10.69.26,23.88S260.1,223.08,260,223.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.33,235.39v1.1h-1v-1.07a4.72,4.72,0,0,1-2.46-.79l.54-1.21a4,4,0,0,0,1.92.7v-1.65c-1.1-.26-2.32-.63-2.32-2,0-1.05.76-1.94,2.32-2.12v-1.1h1v1.08a4.39,4.39,0,0,1,2,.6l-.49,1.21a4.22,4.22,0,0,0-1.51-.51v1.68c1.09.26,2.3.62,2.3,2C144.63,234.31,143.88,235.2,142.33,235.39Zm-1-4.37v-1.4c-.52.12-.73.41-.73.73S140.9,230.88,141.34,231Zm1.7,2.38c0-.34-.29-.53-.71-.68v1.36C142.82,234,143,233.72,143,233.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.24,234v1.31H148v-1l2.67-2.52c.61-.58.72-.93.72-1.27,0-.54-.38-.86-1.11-.86a1.7,1.7,0,0,0-1.43.69l-1.16-.75a3.2,3.2,0,0,1,2.74-1.28c1.54,0,2.57.79,2.57,2a2.75,2.75,0,0,1-1.16,2.18l-1.59,1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.89,231.85c0-2.28,1.26-3.57,3-3.57s3,1.29,3,3.57-1.25,3.58-3,3.58S153.89,234.13,153.89,231.85Zm4.31,0c0-1.57-.55-2.22-1.35-2.22s-1.34.65-1.34,2.22.55,2.22,1.34,2.22S158.2,233.42,158.2,231.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.33,234.42a2.29,2.29,0,0,1-.27,1l-.56,1.42h-1l.44-1.57a.86.86,0,0,1-.54-.84,1,1,0,0,1,1.91,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.31,234v1.31h-5.22v-1l2.66-2.52c.62-.58.72-.93.72-1.27,0-.54-.37-.86-1.1-.86a1.69,1.69,0,0,0-1.43.69l-1.17-.75a3.21,3.21,0,0,1,2.75-1.28c1.54,0,2.56.79,2.56,2a2.73,2.73,0,0,1-1.15,2.18l-1.59,1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,233.2c0,1.16-.9,2.23-2.87,2.23a4.78,4.78,0,0,1-2.63-.74l.62-1.23a3.3,3.3,0,0,0,2,.62c.8,0,1.3-.32,1.3-.88s-.39-.85-1.3-.85h-.73v-1.06l1.42-1.61h-2.94V228.4h4.84v1l-1.56,1.78A2,2,0,0,1,174.08,233.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.14,233.86H180v1.45h-1.56v-1.45h-3.72v-1.08L178,228.4h1.67l-3,4.15h1.86v-1.29H180v1.29h1.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,234.42a1,1,0,0,1,1.91,0,1,1,0,1,1-1.91,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.27,231.85c0-2.28,1.27-3.57,3-3.57s3,1.29,3,3.57-1.26,3.58-3,3.58S184.27,234.13,184.27,231.85Zm4.32,0c0-1.57-.55-2.22-1.35-2.22s-1.35.65-1.35,2.22.56,2.22,1.35,2.22S188.59,233.42,188.59,231.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,231.85c0-2.28,1.26-3.57,3-3.57s3,1.29,3,3.57-1.25,3.58-3,3.58S191,234.13,191,231.85Zm4.31,0c0-1.57-.55-2.22-1.35-2.22s-1.34.65-1.34,2.22.55,2.22,1.34,2.22S195.29,233.42,195.29,231.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.05,242.86h-.9v.88h-.3v-.88h-.91v-.29h.91v-.88h.3v.88h.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.94,244.44V245h-.25v-.55a1.78,1.78,0,0,1-1.15-.44l.14-.28a1.61,1.61,0,0,0,1,.41v-1.28c-.53-.13-1.07-.29-1.07-.93,0-.47.33-.87,1.07-.93v-.56h.25V241a1.83,1.83,0,0,1,1,.3l-.12.28a1.9,1.9,0,0,0-.86-.28v1.29c.55.13,1.12.28,1.12.93C144.06,244,143.71,244.39,142.94,244.44Zm-.25-1.93V241.3c-.5,0-.72.3-.72.61S142.3,242.41,142.69,242.51Zm1,1c0-.38-.36-.51-.77-.61v1.21C143.47,244.09,143.71,243.84,143.71,243.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.44,241v3.39h-.35v-3.08h-.8V241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,244.17a.75.75,0,0,1-.07.28l-.2.67h-.23l.16-.7a.24.24,0,0,1-.17-.25.25.25,0,0,1,.25-.26A.25.25,0,0,1,146.77,244.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64,244.1v.31h-2.38v-.25l1.41-1.38c.39-.38.46-.61.46-.84,0-.39-.28-.63-.79-.63a1.14,1.14,0,0,0-.93.38l-.25-.22a1.51,1.51,0,0,1,1.2-.48c.69,0,1.13.35,1.13.91a1.4,1.4,0,0,1-.56,1.07l-1.15,1.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.46,241v.24L151,244.41h-.38l1.4-3.08h-1.75V242H150V241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,241v3.39h-.35v-3.08h-.8V241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.73,244.17a.25.25,0,0,1,.25-.26.26.26,0,0,1,.27.26.27.27,0,0,1-.27.27A.26.26,0,0,1,154.73,244.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,243.41c0,.58-.41,1-1.24,1a1.76,1.76,0,0,1-1.22-.44l.17-.27a1.48,1.48,0,0,0,1,.39c.58,0,.88-.28.88-.69s-.27-.71-1.13-.71h-.73L156,241h1.86v.31h-1.56l-.11,1.08h.43C157.67,242.41,158.06,242.81,158.06,243.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.44,241v3.39h-.35v-3.08h-.8V241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.09,244.26a.82.82,0,0,1-.54.18.68.68,0,0,1-.74-.75v-1.54h-.46v-.29h.46v-.56h.34v.56h.78v.29h-.78v1.52a.41.41,0,0,0,.44.47A.55.55,0,0,0,163,244Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.37,243.14a1.3,1.3,0,1,1,1.3,1.3A1.26,1.26,0,0,1,163.37,243.14Zm2.25,0a1,1,0,1,0-1,1A.94.94,0,0,0,165.62,243.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,240.81v3.6h-.33v-.5a1.12,1.12,0,0,1-1,.53,1.3,1.3,0,0,1,0-2.6,1.13,1.13,0,0,1,1,.5v-1.53Zm-.34,2.33a1,1,0,1,0-.95,1A.94.94,0,0,0,168.66,243.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,242.83v1.58h-.33V244a1,1,0,0,1-.88.43c-.58,0-.93-.3-.93-.75s.25-.72,1-.72h.81v-.15c0-.44-.24-.68-.72-.68a1.33,1.33,0,0,0-.85.3l-.15-.26a1.63,1.63,0,0,1,1-.34A.91.91,0,0,1,171.89,242.83Zm-.35.82v-.42h-.8c-.49,0-.65.19-.65.45s.24.48.64.48A.81.81,0,0,0,171.54,243.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.92,241.86l-1.28,2.86c-.21.5-.48.66-.84.66a.88.88,0,0,1-.63-.24l.17-.25a.64.64,0,0,0,.46.19c.23,0,.38-.11.53-.43l.11-.24-1.14-2.55h.36l1,2.17,1-2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,293.37v1h-.43v-1a3.14,3.14,0,0,1-2-.78l.24-.48a2.94,2.94,0,0,0,1.79.71v-2.24c-.93-.23-1.89-.52-1.89-1.64,0-.82.59-1.52,1.89-1.63v-1H225v1a3.33,3.33,0,0,1,1.73.52l-.22.51a3.15,3.15,0,0,0-1.51-.5v2.26c1,.23,2,.5,2,1.64C227,292.58,226.37,293.29,225,293.37Zm-.43-3.37v-2.13c-.87.08-1.27.53-1.27,1.06S223.89,289.82,224.59,290Zm1.78,1.79c0-.68-.62-.91-1.35-1.09v2.13C226,292.76,226.37,292.33,226.37,291.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.72,287.37v6h-.61v-5.42H229.7v-.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.14,290.35c0-1.9,1-3,2.38-3s2.38,1.13,2.38,3-1,3-2.38,3S233.14,292.25,233.14,290.35Zm4.13,0c0-1.6-.71-2.47-1.75-2.47s-1.76.87-1.76,2.47.72,2.47,1.76,2.47S237.27,291.94,237.27,290.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,292.9a1.37,1.37,0,0,1-.11.49l-.36,1.18h-.41l.29-1.23a.46.46,0,1,1,.59-.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.52,291.62c0,1-.73,1.76-2.16,1.76a3.11,3.11,0,0,1-2.15-.77l.3-.48a2.6,2.6,0,0,0,1.85.69c1,0,1.53-.46,1.53-1.2s-.5-1.19-1.61-1.19h-.43V290l1.66-2.07h-3v-.54h3.83v.43l-1.69,2.12C243.88,290,244.52,290.66,244.52,291.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34,291.57c0,1-.71,1.81-2.17,1.81a3.05,3.05,0,0,1-2.13-.77l.3-.48a2.57,2.57,0,0,0,1.83.69c1,0,1.54-.5,1.54-1.22s-.47-1.25-2-1.25h-1.27l.31-3H249v.54H246.3l-.21,1.9h.77C248.66,289.81,249.34,290.52,249.34,291.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,291.55a1.86,1.86,0,0,1-2,1.83c-1.59,0-2.45-1.1-2.45-3s1.11-3.08,2.73-3.08a2.72,2.72,0,0,1,1.41.32l-.25.49a2.09,2.09,0,0,0-1.15-.28c-1.29,0-2.12.83-2.12,2.45a4.55,4.55,0,0,0,0,.48,1.92,1.92,0,0,1,1.82-1A1.8,1.8,0,0,1,254.59,291.55Zm-.6,0c0-.78-.58-1.28-1.5-1.28a1.38,1.38,0,0,0-1.53,1.3c0,.66.54,1.28,1.57,1.28A1.31,1.31,0,0,0,254,291.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.39,292.9a.46.46,0,1,1,.91,0,.46.46,0,1,1-.91,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1,290.35c0-1.9,1-3,2.37-3s2.39,1.13,2.39,3-1,3-2.39,3S257.1,292.25,257.1,290.35Zm4.13,0c0-1.6-.72-2.47-1.76-2.47s-1.75.87-1.75,2.47.71,2.47,1.75,2.47S261.23,291.94,261.23,290.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.73,290.35c0-1.9,1-3,2.38-3s2.38,1.13,2.38,3-1,3-2.38,3S262.73,292.25,262.73,290.35Zm4.13,0c0-1.6-.71-2.47-1.75-2.47s-1.76.87-1.76,2.47.72,2.47,1.76,2.47S266.86,291.94,266.86,290.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,322.89v1H238v-1a3.22,3.22,0,0,1-2-.77l.25-.49a2.89,2.89,0,0,0,1.79.71v-2.23c-.94-.23-1.89-.52-1.89-1.65,0-.81.59-1.52,1.89-1.62v-1h.43v1a3.24,3.24,0,0,1,1.72.53l-.21.5a3.18,3.18,0,0,0-1.51-.5v2.26c1,.23,2,.5,2,1.64C240.39,322.1,239.77,322.81,238.42,322.89Zm-.43-3.37v-2.13c-.88.08-1.27.53-1.27,1.07S237.29,319.34,238,319.52Zm1.78,1.79c0-.67-.62-.9-1.35-1.08v2.12C239.35,322.29,239.77,321.85,239.77,321.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12,316.89v6h-.62v-5.42h-1.4v-.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,319.87c0-1.9,1-3,2.37-3s2.39,1.13,2.39,3-1,3-2.39,3S246.54,321.77,246.54,319.87Zm4.13,0c0-1.59-.72-2.47-1.76-2.47s-1.75.88-1.75,2.47.72,2.47,1.75,2.47S250.67,321.46,250.67,319.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,321.14c0,1-.72,1.76-2.16,1.76a3.11,3.11,0,0,1-2.15-.77l.3-.48a2.64,2.64,0,0,0,1.85.69c1,0,1.53-.46,1.53-1.2s-.5-1.19-1.61-1.19h-.42v-.45l1.65-2.07H252v-.54h3.83v.43l-1.68,2.12C255.39,319.51,256,320.18,256,321.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.81,322.42a1.3,1.3,0,0,1-.12.5l-.35,1.17h-.41l.29-1.23a.44.44,0,0,1-.31-.44.45.45,0,0,1,.45-.46A.44.44,0,0,1,257.81,322.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.74,321.1c0,1-.7,1.8-2.16,1.8a3.08,3.08,0,0,1-2.14-.77l.3-.48a2.59,2.59,0,0,0,1.83.69c1,0,1.55-.5,1.55-1.22s-.48-1.24-2-1.24h-1.27l.31-3h3.26v.54H259.7l-.2,1.9h.77C262.06,319.33,262.74,320,262.74,321.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,321.07a1.86,1.86,0,0,1-2,1.83c-1.58,0-2.44-1.1-2.44-3,0-2,1.1-3.08,2.72-3.08a2.76,2.76,0,0,1,1.42.32l-.25.5a2.07,2.07,0,0,0-1.16-.29c-1.28,0-2.11.83-2.11,2.45,0,.13,0,.3,0,.48a1.92,1.92,0,0,1,1.83-1A1.81,1.81,0,0,1,268,321.07Zm-.61,0c0-.79-.58-1.29-1.5-1.29a1.38,1.38,0,0,0-1.53,1.3c0,.66.55,1.28,1.58,1.28A1.3,1.3,0,0,0,267.39,321.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.23,297.17v.66l-1.65,3.77h-1.11l1.59-3.59h-1.47v.72h-.91v-1.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34,301a.6.6,0,0,1,.62-.61.59.59,0,0,1,.61.61.6.6,0,0,1-.61.62A.61.61,0,0,1,249.34,301Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,300.21c0,.78-.58,1.47-1.85,1.47a3,3,0,0,1-1.69-.48l.41-.78a2.15,2.15,0,0,0,1.26.4c.51,0,.83-.22.83-.58s-.23-.58-1-.58h-1.14l.23-2.49h2.7V298h-1.85l-.07.84h.37C253.87,298.83,254.39,299.42,254.39,300.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.52,300.32c0,.83-.75,1.36-1.88,1.36s-1.86-.53-1.86-1.36a1.14,1.14,0,0,1,.67-1.05,1,1,0,0,1-.51-.91c0-.78.7-1.27,1.7-1.27s1.72.49,1.72,1.27a1,1,0,0,1-.52.91A1.13,1.13,0,0,1,258.52,300.32Zm-1,0c0-.39-.32-.63-.84-.63s-.82.24-.82.63.32.64.82.64S257.48,300.68,257.48,300.28ZM256,298.4c0,.34.26.55.68.55s.7-.21.7-.55-.28-.55-.7-.55S256,298.06,256,298.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,298.34a1.11,1.11,0,1,1,1.1,1.22A1.1,1.1,0,0,1,258.85,298.34Zm1.56,0c0-.47-.18-.7-.46-.7s-.46.23-.46.7.19.7.46.7S260.41,298.82,260.41,298.34Zm2.18-1.17h.75l-3,4.43h-.76Zm-.73,3.26a1.11,1.11,0,1,1,1.1,1.22A1.1,1.1,0,0,1,261.86,300.43Zm1.56,0c0-.47-.18-.7-.46-.7s-.46.23-.46.7.19.7.46.7S263.42,300.9,263.42,300.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.73,328.62h1.8v.8h-1.8Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,329.4a1.52,1.52,0,0,1-1.68,1.48c-1.22,0-2-.77-2-2.2a2.16,2.16,0,0,1,2.26-2.39,2.37,2.37,0,0,1,1.24.31l-.38.75a1.5,1.5,0,0,0-.83-.22,1.18,1.18,0,0,0-1.25,1.29,1.51,1.51,0,0,1,1.1-.4A1.41,1.41,0,0,1,248.78,329.4Zm-1,.05a.67.67,0,0,0-.75-.66.7.7,0,0,0-.77.66c0,.38.28.66.78.66A.66.66,0,0,0,247.79,329.45Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.19,330.23a.62.62,0,0,1,1.23,0,.62.62,0,1,1-1.23,0Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.26,330v.83h-3.35v-.66l1.71-1.62c.39-.37.46-.6.46-.81s-.24-.55-.71-.55a1.08,1.08,0,0,0-.92.44l-.75-.48a2.09,2.09,0,0,1,1.77-.83c1,0,1.64.51,1.64,1.31a1.75,1.75,0,0,1-.74,1.4l-1,1Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.4,329.52c0,.83-.75,1.36-1.88,1.36s-1.86-.53-1.86-1.36a1.14,1.14,0,0,1,.67-1,1,1,0,0,1-.51-.91c0-.78.69-1.27,1.7-1.27s1.72.49,1.72,1.27a1,1,0,0,1-.52.91A1.13,1.13,0,0,1,258.4,329.52Zm-1,0c0-.4-.33-.64-.84-.64s-.82.24-.82.64.31.64.82.64S257.36,329.88,257.36,329.49Zm-1.52-1.89c0,.34.26.55.68.55s.7-.21.7-.55-.28-.55-.7-.55S255.84,327.26,255.84,327.6Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.73,327.54a1.1,1.1,0,1,1,1.1,1.22A1.1,1.1,0,0,1,258.73,327.54Zm1.56,0c0-.47-.18-.7-.46-.7s-.46.23-.46.7.19.7.46.7S260.29,328,260.29,327.54Zm2.18-1.17h.75l-3,4.43h-.75Zm-.73,3.26a1.11,1.11,0,1,1,1.1,1.22A1.1,1.1,0,0,1,261.74,329.63Zm1.56,0c0-.47-.19-.7-.46-.7s-.47.23-.47.7.19.7.47.7S263.3,330.1,263.3,329.63Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.22,137.34a3.29,3.29,0,0,1,5.71-2l-.89.82a1.92,1.92,0,0,0-1.5-.7,1.92,1.92,0,0,0,0,3.83,1.89,1.89,0,0,0,1.5-.71l.89.82a3.29,3.29,0,0,1-5.71-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.63,135.66v1.23l-.3,0a1.14,1.14,0,0,0-1.23,1.29v2.17h-1.33v-4.6h1.28v.61A1.83,1.83,0,0,1,143.63,135.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,135.73l-2.08,4.88a1.89,1.89,0,0,1-1.9,1.44,2,2,0,0,1-1.29-.42l.49-.95a1.21,1.21,0,0,0,.75.3c.37,0,.57-.17.75-.58l0,0-2-4.63h1.38l1.29,3.12,1.3-3.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,138a2.23,2.23,0,0,1-2.29,2.36,1.79,1.79,0,0,1-1.38-.55V142H149.7v-6.25H151v.53a1.79,1.79,0,0,1,1.44-.6A2.23,2.23,0,0,1,154.7,138Zm-1.35,0a1.17,1.17,0,1,0-1.17,1.27A1.16,1.16,0,0,0,153.35,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.56,140.1a1.89,1.89,0,0,1-1.09.29,1.51,1.51,0,0,1-1.71-1.65v-1.88h-.71v-1h.71v-1.12h1.33v1.12h1.14v1h-1.14v1.87a.53.53,0,0,0,.57.6.85.85,0,0,0,.54-.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,138a2.53,2.53,0,1,1,2.52,2.36A2.36,2.36,0,0,1,158.83,138Zm3.7,0a1.18,1.18,0,1,0-1.18,1.27A1.17,1.17,0,0,0,162.53,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.23,136.4c0,1.27-.93,2-2.45,2h-1.6v1.89h-.64v-6h2.24C171.3,134.34,172.23,135.11,172.23,136.4Zm-.64,0c0-1-.63-1.51-1.83-1.51h-1.58v3h1.58C171,137.88,171.59,137.34,171.59,136.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,138.08a2.29,2.29,0,1,1,2.29,2.29A2.21,2.21,0,0,1,173,138.08Zm4,0a1.68,1.68,0,1,0-1.67,1.75A1.64,1.64,0,0,0,177,138.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,135.8v.59h-.15a1.45,1.45,0,0,0-1.51,1.66v2.29h-.61v-4.5h.58v.88A1.7,1.7,0,0,1,181.07,135.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,140.05a1.39,1.39,0,0,1-.94.32,1.19,1.19,0,0,1-1.32-1.31v-2.72h-.8v-.51h.8v-1h.61v1h1.36v.51h-1.36V139a.72.72,0,0,0,.77.82,1,1,0,0,0,.67-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.52,135.3v.53h1.38v.51h-1.36v4h-.61v-4h-.8v-.51h.8v-.55a1.24,1.24,0,0,1,1.36-1.34,1.51,1.51,0,0,1,.9.28l-.21.46a1,1,0,0,0-.67-.22C186.79,134.46,186.52,134.75,186.52,135.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,138.08a2.29,2.29,0,1,1,2.29,2.29A2.21,2.21,0,0,1,188.2,138.08Zm4,0a1.67,1.67,0,1,0-1.66,1.75A1.64,1.64,0,0,0,192.15,138.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,134h.6v6.34H194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.17,134.41a.44.44,0,0,1,.45-.42.43.43,0,0,1,.44.41.44.44,0,0,1-.44.45A.45.45,0,0,1,196.17,134.41Zm.14,1.42h.61v4.5h-.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,138.08a2.29,2.29,0,1,1,2.29,2.29A2.21,2.21,0,0,1,198.15,138.08Zm4,0a1.67,1.67,0,1,0-1.67,1.75A1.64,1.64,0,0,0,202.11,138.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59,139.11a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,261.59,139.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59,135.27a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,261.59,135.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59,131.43a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,261.59,131.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,301.43H265a.43.43,0,0,1-.38-.64l.69-1.18.68-1.18a.43.43,0,0,1,.74,0l.68,1.18.68,1.18a.42.42,0,0,1-.37.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,361v1h-.43v-1a3.19,3.19,0,0,1-2-.77l.24-.49a3,3,0,0,0,1.79.72v-2.24c-.94-.23-1.89-.52-1.89-1.65,0-.81.59-1.52,1.89-1.62v-1H228v1a3.24,3.24,0,0,1,1.72.53l-.21.5a3.15,3.15,0,0,0-1.51-.5v2.26c1,.23,2,.5,2,1.64C230,360.2,229.35,360.92,228,361Zm-.43-3.37v-2.13c-.88.08-1.27.53-1.27,1.07S226.87,357.44,227.57,357.62Zm1.78,1.79c0-.67-.62-.9-1.35-1.08v2.13C228.93,360.39,229.35,360,229.35,359.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,355v6h-.61v-5.42h-1.41V355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,359.2c0,1-.71,1.8-2.17,1.8a3.05,3.05,0,0,1-2.13-.77l.29-.48a2.61,2.61,0,0,0,1.83.69c1,0,1.55-.5,1.55-1.22s-.47-1.24-2-1.24h-1.27l.31-3h3.26v.54h-2.72l-.21,1.9h.77C239.48,357.43,240.17,358.14,240.17,359.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86,360.52a1.3,1.3,0,0,1-.12.5l-.36,1.17H241l.29-1.23a.43.43,0,0,1-.3-.44.44.44,0,0,1,.45-.46A.45.45,0,0,1,241.86,360.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.77,359.24c0,1-.72,1.76-2.16,1.76a3.11,3.11,0,0,1-2.15-.77l.3-.48a2.64,2.64,0,0,0,1.85.69c1,0,1.53-.46,1.53-1.2s-.5-1.18-1.61-1.18h-.42v-.46l1.65-2.07h-3V355h3.83v.43l-1.68,2.12C246.13,357.61,246.77,358.28,246.77,359.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.59,359.2c0,1-.7,1.8-2.16,1.8a3.08,3.08,0,0,1-2.14-.77l.3-.48a2.57,2.57,0,0,0,1.83.69c1,0,1.55-.5,1.55-1.22s-.48-1.24-2-1.24h-1.27l.31-3h3.26v.54h-2.73l-.2,1.9h.76C250.91,357.43,251.59,358.14,251.59,359.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.85,359.17a1.86,1.86,0,0,1-2,1.83c-1.58,0-2.44-1.1-2.44-3s1.11-3.08,2.72-3.08a2.76,2.76,0,0,1,1.42.32l-.25.5a2.07,2.07,0,0,0-1.16-.29c-1.28,0-2.11.83-2.11,2.45a4.4,4.4,0,0,0,0,.48,1.9,1.9,0,0,1,1.82-1A1.81,1.81,0,0,1,256.85,359.17Zm-.61,0c0-.79-.58-1.29-1.5-1.29a1.38,1.38,0,0,0-1.53,1.3c0,.66.55,1.28,1.58,1.28A1.3,1.3,0,0,0,256.24,359.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65,360.52a.45.45,0,0,1,.45-.46.47.47,0,0,1,0,.93A.45.45,0,0,1,257.65,360.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,355v6h-.61v-5.42H259V355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.41,358c0-1.9,1-3,2.38-3s2.38,1.13,2.38,3-1,3-2.38,3S262.41,359.87,262.41,358Zm4.13,0c0-1.59-.71-2.47-1.75-2.47S263,356.38,263,358s.71,2.47,1.75,2.47S266.54,359.56,266.54,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,364.79v.67l-1.64,3.77h-1.12l1.59-3.6h-1.47v.72h-.91v-1.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,368.66a.62.62,0,0,1,1.23,0,.62.62,0,1,1-1.23,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.14,367.83c0,.79-.57,1.47-1.84,1.47a3.08,3.08,0,0,1-1.69-.47l.4-.79a2.1,2.1,0,0,0,1.26.4c.52,0,.83-.22.83-.58s-.23-.57-1-.57h-1.13l.22-2.5h2.71v.83H250l-.07.84h.36C251.62,366.46,252.14,367.05,252.14,367.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,367.94c0,.84-.74,1.36-1.87,1.36s-1.86-.52-1.86-1.36a1.11,1.11,0,0,1,.67-1,1,1,0,0,1-.52-.92c0-.78.7-1.26,1.71-1.26s1.71.48,1.71,1.26a1.06,1.06,0,0,1-.51.92A1.11,1.11,0,0,1,256.27,367.94Zm-1,0c0-.39-.32-.63-.83-.63s-.83.24-.83.63.32.64.83.64S255.23,368.3,255.23,367.91ZM253.71,366c0,.33.27.54.69.54s.7-.21.7-.54-.28-.56-.7-.56S253.71,365.68,253.71,366Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.6,366a1.11,1.11,0,0,1,1.11-1.23A1.23,1.23,0,1,1,256.6,366Zm1.57,0c0-.48-.19-.71-.46-.71s-.47.24-.47.71.19.7.47.7S258.17,366.44,258.17,366Zm2.18-1.18h.75l-3,4.44h-.75Zm-.73,3.26a1.11,1.11,0,1,1,2.2,0,1.11,1.11,0,1,1-2.2,0Zm1.56,0c0-.46-.19-.7-.47-.7s-.46.23-.46.7.19.71.46.71S261.18,368.52,261.18,368.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23,369.06h-1.36a.43.43,0,0,1-.37-.64l.68-1.18.68-1.18a.42.42,0,0,1,.74,0l.68,1.18.68,1.18a.43.43,0,0,1-.37.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,327.59h1.36a.42.42,0,0,1,.37.64l-.68,1.18-.68,1.18a.43.43,0,0,1-.74,0l-.68-1.18-.69-1.18a.43.43,0,0,1,.38-.64Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,242.05h-4.21a2.93,2.93,0,0,1-2.93-2.93v-3a2.94,2.94,0,0,1,2.93-2.94h4.21a2.94,2.94,0,0,1,2.93,2.94v3A2.93,2.93,0,0,1,253.49,242.05Zm-4.21-7.88a1.94,1.94,0,0,0-1.93,1.94v3a1.93,1.93,0,0,0,1.93,1.93h4.21a1.92,1.92,0,0,0,1.93-1.93v-3a1.93,1.93,0,0,0-1.93-1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,240.16a.51.51,0,0,1-.5-.5v-2.31a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.31A.5.5,0,0,1,249.22,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.13,240.16a.5.5,0,0,1-.5-.5V236.2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.46A.51.51,0,0,1,251.13,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,240.16a.51.51,0,0,1-.5-.5v-4.61a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v4.61A.5.5,0,0,1,253.43,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.71,361.62a2.18,2.18,0,0,1-.35-3.67,1.88,1.88,0,0,0-1.61-2v-1.23h-1.14v1.15H141v-1.15h-1.15v1.15h-1.76v1.14h.72v5.56H138v1.14h1.84v1.34H141v-1.34h.65v1.34h1.14v-1.38A2,2,0,0,0,144.71,361.62Zm-4.49-4.57h1.55c.86,0,1.34.36,1.34,1.09s-.48,1.07-1.34,1.07H140v-2.16Zm1.8,5.56h-2v-2.27h2c.93,0,1.44.35,1.44,1.14S143,362.61,142,362.61Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,180.74l-.24-.24-.67-.72-2.62-2.86.13,0c-.71,1.29-1.6,2.87-2.62,4.71l-.11.21-.1-.22L247.05,170h.31c-.85,2.43-1.78,5.11-2.78,8v0c-.39,3.05-.82,6.34-1.26,9.8v0l0,0-2.84,5.11-.05.09-.1,0-2.84.62h-.06l-7.56-.19.16-.06-6.94,5.93-.28.24-.11-.35c-.47-1.52-1-3.07-1.38-4.73,0-.11,0-.2-.06-.34V194s0,.06,0,.08.06,0,0,0a2.88,2.88,0,0,0-.53.13c-.39.13-.77.3-1.16.47-.77.34-1.54.72-2.31,1.12l-.16.08-.13-.13c-.9-.89-1.88-1.87-2.86-2.86l.35,0c-1,.89-2.14,1.87-3.27,2.86L211,196l-.16-.22-3.68-4.9.46-.11c-.45,2.34-.94,4.83-1.43,7.35l0,.14-.13.05-.08,0-2.89,1.2.09-.06-3.37,3.27,0-.05-2.66,4.07,0,.05,0,0-2.86,1.64,0,0h0l-4.08.81-.16,0-.1-.13c-.61-.83-1.23-1.65-1.83-2.47l.25.1-6.13,1.23-.14,0-.1-.11-8.15-9.81.38,0L165.94,212l-.17.28-.19-.26-2.44-3.36.31,0-4.3,4.48-.15.16-.13-.17-3.46-4.5h.26l-6.56,6.69-.09.1-.1-.1-2.44-2.43h.18l-2.26,2.41-.08.09-.08-.09-4.21-5L139,209l-.35-.46.4.42,1.11,1.27,4.29,4.95h-.16l2.23-2.44.09-.09.09.09,2.46,2.41h-.19l6.5-6.74.14-.14.12.16,3.49,4.48-.29,0,4.28-4.5.16-.17.15.19,2.45,3.35-.35,0L173.72,198l.17-.29.21.26,8.18,9.79-.24-.08,6.12-1.25.16,0,.09.13,1.84,2.46-.25-.1,4.08-.81-.08,0,2.86-1.64-.09.08q1.32-2,2.65-4.07l0,0,0,0,3.36-3.27,0,0,0,0,2.89-1.19.08,0-.16.19c.49-2.52,1-5,1.43-7.35l.12-.57.35.47,3.67,4.9-.38,0,3.27-2.86.18-.16.17.17,2.86,2.86-.3,0c.77-.4,1.55-.78,2.33-1.13.4-.18.8-.35,1.21-.49a2.69,2.69,0,0,1,.7-.15.45.45,0,0,1,.34.14c.06.05.08.22.08.23v.06c0,.07,0,.19,0,.28.39,1.6.89,3.17,1.36,4.68l-.4-.12L229.7,193l.07-.06h.09l7.57.21h-.06l2.85-.6-.15.11,2.87-5.1,0,.07c.46-3.45.9-6.74,1.3-9.79v0c1-2.85,2-5.53,2.83-8l.14-.39.17.38,5.06,11.66h-.21c1-1.83,1.95-3.4,2.68-4.68l.06-.1.07.09c1.12,1.26,2,2.24,2.56,2.91l.65.76C258.37,180.65,258.44,180.73,258.43,180.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.26 220.16 154.58 218.01 152.08 220.03 145.94 220.03 140.53 215.6 141.17 214.82 146.3 219.03 151.72 219.03 154.58 216.73 157.26 218.88 163.8 213.69 169.09 216.38 182.28 213.76 188.02 216.37 195.47 213.81 199.45 212.17 208.99 209.17 212.21 212.83 215.82 214.1 223.97 210.58 227.85 204.87 230.78 210.27 235.69 210.08 240.22 207.06 243.05 209.45 249.12 202.07 253.71 209.93 257.53 210.83 259.67 212.44 259.07 213.24 257.01 211.7 253.06 210.81 248.98 203.81 243.18 210.87 240.15 208.31 236.01 211.07 230.2 211.29 227.76 206.79 224.63 211.39 215.86 215.17 211.63 213.68 208.67 210.32 199.79 213.11 195.82 214.75 187.97 217.44 182.16 214.81 168.95 217.43 163.92 214.88 157.26 220.16",
    style: {
      fill: "#455a64"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M274.45,271c0,.15-34.29.26-76.58.26s-76.58-.11-76.58-.26,34.28-.26,76.58-.26S274.45,270.82,274.45,271Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,308.23c0,.14-34.29.26-76.58.26s-76.58-.12-76.58-.26,34.28-.26,76.58-.26S274.45,308.08,274.45,308.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,342.85c0,.14-34.29.26-76.58.26s-76.58-.12-76.58-.26,34.28-.26,76.58-.26S274.45,342.7,274.45,342.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,380.11c0,.14-34.29.26-76.58.26s-76.58-.12-76.58-.26,34.28-.26,76.58-.26S274.45,380,274.45,380.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.49,403.38h-24a8.8,8.8,0,0,1-8.8-8.8h0a8.8,8.8,0,0,1,8.8-8.81h24a8.8,8.8,0,0,1,8.8,8.81h0A8.8,8.8,0,0,1,257.49,403.38Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.26,395.45c0,.77-.61,1.21-1.77,1.21H239.2v-4.43h2.16c1.11,0,1.68.46,1.68,1.15a1.13,1.13,0,0,0,.22,2.07Zm-3-2.45v1.05h1c.5,0,.77-.18.77-.53s-.27-.52-.77-.52Zm2,2.34c0-.37-.29-.55-.82-.55h-1.19v1.1h1.19C241.94,395.89,242.23,395.72,242.23,395.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,394.71v-2.48h1v2.44c0,.84.37,1.19,1,1.19s1-.35,1-1.19v-2.44h1v2.48a2,2,0,1,1-4,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.1,395.09v1.57h-1v-1.58l-1.71-2.85h1.09l1.18,2,1.19-2h1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.41,
    y: 98.99,
    width: 1.56,
    height: 2.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.95,
    y: 98.01,
    width: 1.56,
    height: 3.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 97.28,
    width: 1.56,
    height: 3.9,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.04,
    y: 95.87,
    width: 1.56,
    height: 5.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.68,101.29h-7.85a.56.56,0,0,1-.56-.56v-3.9a.56.56,0,0,1,.56-.56h7.85a.14.14,0,0,1,.1,0,.18.18,0,0,1,0,.1V97.7h.84a.14.14,0,0,1,.14.14v1.88a.14.14,0,0,1-.14.14h-.84v1.29A.14.14,0,0,1,266.68,101.29Zm-.15-4.74h-7.7a.27.27,0,0,0-.27.28v3.9a.27.27,0,0,0,.27.27h7.7V99.72a.15.15,0,0,1,.15-.15h.84V98h-.84a.15.15,0,0,1-.15-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.2 100.36 259.2 97.19 265.89 97.19 265.89 98.62 265.89 98.93 265.89 100.36 259.2 100.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08,101a.57.57,0,1,0-.57.57A.56.56,0,0,0,251.08,101Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,99.61l.74.73a1.71,1.71,0,0,1,2.44,0l.74-.73a2.78,2.78,0,0,0-3.92,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.51,97.17a4.38,4.38,0,0,0-3.11,1.29l.73.73a3.36,3.36,0,0,1,4.76,0l.73-.73A4.38,4.38,0,0,0,250.51,97.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.21,97.27l.73.73a5,5,0,0,1,7.14,0l.73-.73a6.06,6.06,0,0,0-8.6,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.14,427.22l2.67,26.92,8.26,20.68a2.77,2.77,0,0,1-1.73,3.66h0a2.73,2.73,0,0,1-2.5-.41c-4.58-3.43-21-16.38-21.26-17.8-.42-2.26-4.89-28.51-4.89-28.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.34,478.48l-24.16-20.32.13,1.13a4.41,4.41,0,0,0,1.32,2.57c1.95,1.79,7.44,6.63,20.13,16.22a2.75,2.75,0,0,0,2.58.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.62,448.82a1.68,1.68,0,0,1,.73,2.12,1.62,1.62,0,0,1-2.1.73,1.78,1.78,0,0,1-.75-2.25,1.68,1.68,0,0,1,2.26-.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,467.5c.16.06.59-1.42,2.1-2.37a8.31,8.31,0,0,1,3-1c0-.07-.35-.24-1-.25a4.41,4.41,0,0,0-4,2.59C387.69,467.09,387.7,467.49,387.77,467.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,470.86c.15.1.9-.87,2.24-1.44a21.88,21.88,0,0,1,2.58-.66c.06-.15-1.3-.56-2.82.11S390,470.81,390.12,470.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.65,463.33a26.44,26.44,0,0,1,3.3-2.46,27.29,27.29,0,0,1,3.87-1.42,7.54,7.54,0,0,0-7.17,3.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,455.22c.09.15,1.5-.65,3.42-1s3.51,0,3.55-.2a6.83,6.83,0,0,0-7,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,430.37l1,22.4s-22.44,8.53-22.67,12.68l43.52-.34-.1-35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,450.78a1.79,1.79,0,0,1,1.25,2,1.71,1.71,0,0,1-2,1.25,1.87,1.87,0,0,1-1.31-2.14,1.76,1.76,0,0,1,2.21-1.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.43,465.11l-.15-3.52-41.67,1.64s-1.93.86-1.7,2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,452.56c0,.21,1.08.3,2.13,1s1.61,1.57,1.81,1.48-.13-1.31-1.42-2.1S323.83,452.36,323.87,452.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.33,454.48c-.05.21.87.56,1.6,1.46s.94,1.84,1.16,1.83.33-1.22-.59-2.31S319.33,454.28,319.33,454.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.78,460c.19.05.48-1-.08-2.18s-1.55-1.61-1.64-1.43.53.79,1,1.75S316.56,460,316.78,460Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.22,447.43c.09.19,1.06-.11,2.26,0s2.14.45,2.25.26-.79-.93-2.21-1S324.11,447.26,324.22,447.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,261.48c0,1.37-8.82,185.75-8.82,185.75l-22.87.22-7.44-156.82s-9.56,82.4-9.56,84.22-2.71,73.49-2.71,73.49H323.07V277.43l15.47-25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,448.34a3.24,3.24,0,0,0,0-.41c0-.31,0-.71,0-1.23,0-1.1,0-2.68,0-4.7.07-4.09.18-10,.4-17.3.44-14.6,1.27-34.77,2.3-57s2.06-42.41,2.77-57c.35-7.27.64-13.17.83-17.28.09-2,.15-3.6.2-4.7,0-.52,0-.92,0-1.22a2.66,2.66,0,0,0,0-.42,3.37,3.37,0,0,0-.05.41c0,.3,0,.71-.09,1.22-.07,1.11-.17,2.68-.29,4.7-.24,4.11-.58,10-1,17.27-.82,14.59-1.89,34.75-2.93,57s-1.81,42.44-2.15,57.05c-.16,7.31-.22,13.22-.23,17.31,0,2,.05,3.6.06,4.7q0,.78,0,1.23A2.18,2.18,0,0,0,335.39,448.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.54,287c-.14,0-.13,35.9,0,80.16s.42,80.16.56,80.16.14-35.88,0-80.16S377.69,287,377.54,287Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.66,281.82a4.15,4.15,0,0,0,1.09.48c.71.28,1.75.66,3,1.12l.25.08,0-.26c.15-2.27.32-5.3.47-8.63.17-3.6.3-6.86.36-9.22,0-1.18.05-2.14.05-2.8a4.43,4.43,0,0,0-.05-1,3.61,3.61,0,0,0-.15,1c-.07.66-.14,1.61-.22,2.79-.16,2.36-.35,5.62-.52,9.22-.16,3.32-.27,6.36-.34,8.63l.26-.18c-1.3-.41-2.36-.74-3.09-1A4.67,4.67,0,0,0,357.66,281.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,262.22s-.09-.15-.36-.24a1.64,1.64,0,0,0-2.09,1.66,1.88,1.88,0,0,0,1.43,1.66,1.93,1.93,0,0,0,2-.94,1.75,1.75,0,0,0,0-1.79,1.72,1.72,0,0,0-.88-.78c-.27-.1-.43-.09-.43-.06s.6.22,1,1a1.41,1.41,0,0,1-.06,1.36,1.48,1.48,0,0,1-1.46.68,1.42,1.42,0,0,1-1.05-1.19,1.18,1.18,0,0,1,.59-1.17A2.09,2.09,0,0,1,359.7,262.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,264.16c.15,0,.35-.81.46-1.83s.07-1.86-.08-1.88-.35.81-.45,1.83S347.21,264.14,347.35,264.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,264c.14,0,.27-.87.27-2s-.11-1.94-.25-1.94-.28.87-.28,1.94S345.34,264,345.49,264Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.91,265.27a5.06,5.06,0,0,0,.5-2.19,4.73,4.73,0,0,0,0-2.24,4.93,4.93,0,0,0-.5,2.18A4.78,4.78,0,0,0,377.91,265.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,265.45a5.11,5.11,0,0,0,.19-4.63,108.36,108.36,0,0,1-.19,4.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,116.79a2.78,2.78,0,0,0-1-1.59,6.71,6.71,0,0,0-4.19-1,17.67,17.67,0,0,1-1.72-5.57,3.59,3.59,0,0,0,2-.57l.32-.09c1.41-.65,1.55-2.76.66-4a8.13,8.13,0,0,0-3.85-2.48c1.06.07,2,.77,3,1.09s2.45,0,2.57-1.09a2.43,2.43,0,0,0-.16-1l-.6-1.87a2.1,2.1,0,0,0-.82-1.31A5,5,0,0,0,398.3,97c-1.19-.32-1.8-1.76-3-2.09a5.38,5.38,0,0,0-2.66.39c-.88.21-2.05,0-2.32-.83a8.51,8.51,0,0,0,3-2.55,2.9,2.9,0,0,0-.29-3.65,4.28,4.28,0,0,0-3-.62c-1.16.06-2.61.32-2.91,1.44a3,3,0,0,0-3.71,2.37l-3-.3c.84-.9,2-1.45,2.75-2.44s.59-2.78-.61-3a7.42,7.42,0,0,1-1.34-.12c-.3-.11-.55-.39-.87-.4a1.15,1.15,0,0,0-.65.26l-6.31,4.12c.56-1.33,1.13-2.65,1.7-4s.94-2.91-.16-3.66-2.6.32-2.82,1.59a2.05,2.05,0,0,0-2.5,1.89,2.08,2.08,0,0,0-2.45,3.18,5.9,5.9,0,0,0-3,.89,1.81,1.81,0,0,0-2.93-1.24,3.2,3.2,0,0,0-.46-1.81,1.09,1.09,0,0,0-1.63-.18,2.12,2.12,0,0,0-3.43-2.07l-1-1.26A2.8,2.8,0,0,0,352,84.31c-.44,1,.3,2.38,1.36,2.29-.74,0-.58,1.18-.14,1.79l1.83,2.54a2.36,2.36,0,0,0-2.9-.26,1.82,1.82,0,0,0-2.62,0,1.46,1.46,0,0,0-2.63.45c-.19-.49-.86-.52-1.38-.46a3.37,3.37,0,0,0-2.09.72c-.53.52-.53,1.62.17,1.88-.64-.36-1.46.34-1.47,1.08a2.6,2.6,0,0,0,1,1.85,6,6,0,0,1,1.5,1.59,3.1,3.1,0,0,0-2.11-.45,8.11,8.11,0,0,0-3.82.77c-.22-.52-.95-.54-1.5-.43a9,9,0,0,0-4.56,2.48c-.58.59-1.1,1.48-.7,2.2a2.11,2.11,0,0,0,.84.75l4.05,2.51a11,11,0,0,0-5.54,3.93c-.81.47-1.84.52-2.58,1.1s-.68,2.13.26,2.13a1.62,1.62,0,0,0,.14,2.7,2.59,2.59,0,0,0,.44.5,3.17,3.17,0,0,0,1.09.57,2.13,2.13,0,0,0,1.81.84,8.54,8.54,0,0,0-1.92,2.28,3.6,3.6,0,0,0,0,3.72c0,.06.1.11.14.16a1.75,1.75,0,0,0,.78,1.12,1.48,1.48,0,0,0-.14,1,4,4,0,0,0-.89,6.94c.93.66,2.66.54,2.75-.6a3.07,3.07,0,0,0,2.34,1.7,3,3,0,0,0,1.56,4.11,3.18,3.18,0,0,0,1,5.21,2.43,2.43,0,1,0,4.6,1.59,5.23,5.23,0,0,0,1.82,2.29,1.8,1.8,0,0,0,2.53-.66,3.33,3.33,0,0,0,4.91,1.59,2.17,2.17,0,0,0,4.31.38l5.58-.05a20.81,20.81,0,0,0,3.7-.27,10,10,0,0,0,4.25-2,2.35,2.35,0,0,1,3-.52,9.05,9.05,0,0,0,8.59-2,4.91,4.91,0,0,1,1.13-.91,4,4,0,0,1,1.65-.22,16.47,16.47,0,0,0,4.07-.59,4.3,4.3,0,0,0,2.86-1.88c.53-1.05-.09-2.67-1.27-2.65a2.52,2.52,0,0,1,.62-2.12,1.54,1.54,0,0,1,2.07-.09,1.1,1.1,0,0,1-.51,1.79c1.27.87,3.23-.35,3.26-1.89a3,3,0,0,0-3-2.82,6.91,6.91,0,0,0,.09-3.38,2.49,2.49,0,0,0,3.39.39,4.28,4.28,0,0,0,2.77,2,2.56,2.56,0,0,0,2.83-1.55,1.85,1.85,0,0,0-1.75-2.38,2.21,2.21,0,0,0-2-3.19,3.43,3.43,0,0,0-2.09-3.65,1.8,1.8,0,0,0,2.57-1c.71,1.12,2.44.85,3.59.17A2.41,2.41,0,0,0,403.22,116.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.21,116.79a1.46,1.46,0,0,1,.07.45,2,2,0,0,1-.43,1.29,4.39,4.39,0,0,1-1.86,1.28,3.66,3.66,0,0,1-1.44.24,1.82,1.82,0,0,1-1.48-.77l.12,0a1.88,1.88,0,0,1-2.68,1l.08-.14a3.53,3.53,0,0,1,2.16,3.73l-.1-.11a2.14,2.14,0,0,1,1.92,1,2.18,2.18,0,0,1,.14,2.31l-.11-.17a1.86,1.86,0,0,1,1.87,1.41,2,2,0,0,1-.94,2.32,3,3,0,0,1-2.69.25,4.74,4.74,0,0,1-2.18-1.86l.19,0a2.63,2.63,0,0,1-3.58-.4l.25-.12a7.23,7.23,0,0,1-.08,3.45l-.14-.18a3.38,3.38,0,0,1,2.08.77,2.84,2.84,0,0,1,1.09,2,2.38,2.38,0,0,1-1.1,2.07,2.12,2.12,0,0,1-2.4.13l-.35-.25.42,0a.9.9,0,0,0,.63-1.05,1,1,0,0,0-1.06-.77,1.51,1.51,0,0,0-1.28.77,2.61,2.61,0,0,0-.28,1.61l-.17-.15a1.47,1.47,0,0,1,1.11.52,2.17,2.17,0,0,1,.5,1.1,2.14,2.14,0,0,1-.16,1.22,2.81,2.81,0,0,1-.75,1,5.91,5.91,0,0,1-2.15,1.05,18.11,18.11,0,0,1-2.35.48c-1.58.33-3.4-.31-4.44,1.15a9,9,0,0,1-4.51,2.32,9.11,9.11,0,0,1-2.61.16,14.13,14.13,0,0,1-2.57-.56,1.57,1.57,0,0,0-1.15.13,10.47,10.47,0,0,0-1,.76,10.12,10.12,0,0,1-2.38,1.34,14.42,14.42,0,0,1-5.46.78l-5.6.06.2-.18a2.37,2.37,0,0,1-4.72-.42l.34.18a3.56,3.56,0,0,1-5.25-1.69h.41a1.62,1.62,0,0,1-1.19,1,2.29,2.29,0,0,1-1.58-.18,5.2,5.2,0,0,1-2-2.4l.41,0a2.66,2.66,0,1,1-5-1.75l.15.29a3.17,3.17,0,0,1-2-2.42,3.23,3.23,0,0,1,.95-3.18l.07.4a3.23,3.23,0,0,1-1.69-4.44l.17.34a3.31,3.31,0,0,1-2.52-1.83l.45-.08a1.17,1.17,0,0,1-.37.77,1.56,1.56,0,0,1-.73.38,2.65,2.65,0,0,1-1.55-.13,4,4,0,0,1-2-2.32,4.08,4.08,0,0,1,.17-3.12,4.29,4.29,0,0,1,2.31-2.16l-.15.27a1.7,1.7,0,0,1,.17-1.14l.09.31a2,2,0,0,1-.89-1.28l.06.11a3.52,3.52,0,0,1-.46-3.53,7.77,7.77,0,0,1,2.25-3l.18.41a2.34,2.34,0,0,1-2-.93l.12.09a3,3,0,0,1-1.66-1.17l.07.07a1.81,1.81,0,0,1-.88-1.46,2,2,0,0,1,.72-1.63l.15.43a.9.9,0,0,1-.75-.38,1.43,1.43,0,0,1-.25-.76,1.78,1.78,0,0,1,.6-1.42c.83-.64,1.85-.68,2.6-1.12l-.08.06a11.33,11.33,0,0,1,5.67-4l-.06.43-1.85-1.15-1.41-.87a12.42,12.42,0,0,1-1.42-.94,1.44,1.44,0,0,1-.45-.86,1.76,1.76,0,0,1,.15-.92,4,4,0,0,1,1.05-1.38,9.24,9.24,0,0,1,2.83-1.79,9.94,9.94,0,0,1,1.61-.48,2.47,2.47,0,0,1,.9,0A1.06,1.06,0,0,1,339,98l-.34-.11a6.83,6.83,0,0,1,3.07-.76c.52,0,1-.05,1.56,0a2.57,2.57,0,0,1,1.58.51l-.37.29c-.45-.9-1.56-1.37-2.21-2.38a1.79,1.79,0,0,1-.21-1.78,1.52,1.52,0,0,1,.67-.68,1.07,1.07,0,0,1,1,0l-.2.43a1.07,1.07,0,0,1-.64-.69,1.64,1.64,0,0,1,0-.88,1.46,1.46,0,0,1,.45-.75,2,2,0,0,1,.71-.44,6,6,0,0,1,1.53-.3,2.52,2.52,0,0,1,.82,0,1,1,0,0,1,.74.59l-.46,0a1.7,1.7,0,0,1,3.08-.52l-.39,0a2,2,0,0,1,3,0l-.32,0a2.58,2.58,0,0,1,3.2.27l-.35.31-1.55-2.16a3.13,3.13,0,0,1-.65-1.24,1.81,1.81,0,0,1,0-.77.77.77,0,0,1,.25-.39.68.68,0,0,1,.46-.14l0,.46a1.56,1.56,0,0,1-1.5-.92,1.94,1.94,0,0,1-.07-1.74,3,3,0,0,1,2.88-1.48h.1l.07.08c.35.43.69.85,1,1.26l-.33,0a2.35,2.35,0,0,1,3.8,2.3l-.4-.19a1.08,1.08,0,0,1,1.08-.35,1.49,1.49,0,0,1,.92.56,3.46,3.46,0,0,1,.5,1.9l-.39-.14a2,2,0,0,1,3.31,1.41l-.34-.2a6.15,6.15,0,0,1,3.12-.92l-.17.35a2.3,2.3,0,0,1,2.7-3.51l-.3.2a2.27,2.27,0,0,1,2.78-2.1l-.27.17a2.48,2.48,0,0,1,.85-1.43,2.18,2.18,0,0,1,1.56-.57,1.67,1.67,0,0,1,1.34,1,2.84,2.84,0,0,1,.13,1.6,13.38,13.38,0,0,1-1,2.85l-1.17,2.71-.3-.25,3.91-2.55,1.91-1.24a5,5,0,0,1,1-.59.89.89,0,0,1,.68.11c.18.1.33.21.47.27a3,3,0,0,0,1,.08,1.5,1.5,0,0,1,1.1.54,2.42,2.42,0,0,1,.22,2.28A4.2,4.2,0,0,1,382.22,90a13.24,13.24,0,0,0-1.61,1.33l-.12-.32,3,.31-.21.16a3.21,3.21,0,0,1,4-2.52l-.23.12a2.08,2.08,0,0,1,1.52-1.33,7.19,7.19,0,0,1,1.93-.24,5.4,5.4,0,0,1,1.91.21A2.34,2.34,0,0,1,393.79,89a3.5,3.5,0,0,1-.62,3.52,10.17,10.17,0,0,1-2.75,2.14l.07-.19a1.21,1.21,0,0,0,1,.76,3,3,0,0,0,1.42-.11,8.54,8.54,0,0,1,1.45-.36,2.19,2.19,0,0,1,1.48.28c.86.53,1.37,1.38,2.16,1.76a12.88,12.88,0,0,0,1.3.33,1.72,1.72,0,0,1,.88,1.09l.79,2.47a1.51,1.51,0,0,1-.1,1.31,1.73,1.73,0,0,1-1.08.7,2.88,2.88,0,0,1-1.24,0,6.37,6.37,0,0,1-1.11-.42,6.13,6.13,0,0,0-2.07-.73l0-.22a13.51,13.51,0,0,1,2.45,1.17,4.6,4.6,0,0,1,1.72,1.84,3.4,3.4,0,0,1,.17,2.3,2.07,2.07,0,0,1-1.49,1.48h0a3.58,3.58,0,0,1-2,.57l.09-.09a17.68,17.68,0,0,0,1.69,5.55l-.05,0a10.77,10.77,0,0,1,2.8.34,3.86,3.86,0,0,1,1.7,1,2.71,2.71,0,0,1,.6,1,1.32,1.32,0,0,1,.08.37,2.67,2.67,0,0,0-.73-1.31,3.81,3.81,0,0,0-1.68-1,10.56,10.56,0,0,0-2.78-.31h0l0,0a17.88,17.88,0,0,1-1.75-5.59v-.1h.1a3.41,3.41,0,0,0,1.93-.55h0a1.9,1.9,0,0,0,1.35-1.36,3.15,3.15,0,0,0-.17-2.17,4.33,4.33,0,0,0-1.65-1.73,14.64,14.64,0,0,0-2.42-1.15l-.69-.27.74,0a6.14,6.14,0,0,1,2.16.73,5.24,5.24,0,0,0,1.06.4,2.69,2.69,0,0,0,1.13,0,1.52,1.52,0,0,0,.92-.59,1.31,1.31,0,0,0,.06-1.1L400,98.29a1.45,1.45,0,0,0-.73-.93,11,11,0,0,1-1.32-.33c-.89-.44-1.4-1.3-2.18-1.76s-1.76-.17-2.7.11a3.24,3.24,0,0,1-1.55.13,1.52,1.52,0,0,1-1.29-1l0-.12.11-.06a9.92,9.92,0,0,0,2.65-2.08,3.14,3.14,0,0,0,.57-3.17A2,2,0,0,0,392.25,88a5,5,0,0,0-1.79-.18,7,7,0,0,0-1.83.23,1.71,1.71,0,0,0-1.28,1.09l-.05.18-.18-.06a2.85,2.85,0,0,0-3.47,2.23l0,.17h-.17l-3-.3-.38,0,.26-.28A13.17,13.17,0,0,1,382,89.68a3.78,3.78,0,0,0,1.32-1.53,2.08,2.08,0,0,0-.16-1.9,1.05,1.05,0,0,0-.82-.38,3.28,3.28,0,0,1-1.17-.12c-.39-.19-.64-.44-.9-.35a5,5,0,0,0-.91.53l-1.9,1.25-3.9,2.55-.57.37.27-.62c.38-.9.77-1.8,1.16-2.71a13.27,13.27,0,0,0,1-2.76,2.39,2.39,0,0,0-.1-1.36,1.26,1.26,0,0,0-1-.75,2.07,2.07,0,0,0-1.95,1.65l0,.24-.23-.07a1.85,1.85,0,0,0-2.22,1.69v.32l-.3-.12a1.86,1.86,0,0,0-2.19,2.84l.26.35h-.43a5.69,5.69,0,0,0-2.89.86l-.36.23,0-.42a1.6,1.6,0,0,0-2.55-1.09l-.36.36,0-.5a3,3,0,0,0-.41-1.66c-.28-.4-1-.57-1.28-.2l-.63.84.23-1a1.89,1.89,0,0,0-3.06-1.84l-.18.14-.15-.17-1-1.26.17.08a2.58,2.58,0,0,0-2.45,1.22c-.41.79.22,2.08,1.11,2l0,.46c-.15,0-.2,0-.25.2a1.1,1.1,0,0,0,0,.54,2.49,2.49,0,0,0,.57,1.07l1.55,2.15-.35.31a2.12,2.12,0,0,0-2.6-.24l-.17.13-.14-.16a1.58,1.58,0,0,0-2.27,0l-.24.29-.15-.34a1.24,1.24,0,0,0-2.19.37l-.1,1.18-.36-1.13c-.09-.3-.61-.36-1.07-.31a5.79,5.79,0,0,0-1.4.27,1.33,1.33,0,0,0-.87.87c-.11.41,0,.89.36,1l-.2.44c-.33-.2-.82.08-1,.48a1.33,1.33,0,0,0,.19,1.3c.53.87,1.65,1.33,2.24,2.42l.56,1-.93-.75c-.69-.55-1.81-.37-2.8-.35a6.42,6.42,0,0,0-2.86.69l-.24.15-.1-.26c-.13-.34-.71-.39-1.18-.29a8,8,0,0,0-1.52.45,8.75,8.75,0,0,0-2.68,1.69,3.61,3.61,0,0,0-.94,1.21,1,1,0,0,0,.2,1.25,10.58,10.58,0,0,0,1.33.88l1.41.87,1.86,1.15.45.28-.51.16a10.82,10.82,0,0,0-5.42,3.84l0,0,0,0c-.9.51-1.89.56-2.54,1.09a1.26,1.26,0,0,0-.42,1c0,.39.21.7.52.68l.76,0-.61.47a1.51,1.51,0,0,0-.54,1.23,1.29,1.29,0,0,0,.66,1.07l0,0,0,0a2.51,2.51,0,0,0,1.4,1l.08,0,0,.06a1.91,1.91,0,0,0,1.6.74l.72-.07-.54.48a7.44,7.44,0,0,0-2.12,2.78,3,3,0,0,0,.36,3.05l0,0v.06a1.58,1.58,0,0,0,.67,1l.19.11-.1.2a1.24,1.24,0,0,0-.12.83l0,.2-.19.07a3.83,3.83,0,0,0-2.06,1.92,3.58,3.58,0,0,0-.14,2.76,3.48,3.48,0,0,0,1.73,2.05,2.22,2.22,0,0,0,1.27.11A.86.86,0,0,0,333,132l.06-.91.39.83a2.86,2.86,0,0,0,2.16,1.57l.34,0-.17.31a2.76,2.76,0,0,0,1.43,3.77l.4.13-.33.27a2.76,2.76,0,0,0-.79,2.73,2.72,2.72,0,0,0,1.72,2.08l.22.07-.08.22a2.3,2.3,0,0,0,1.45,2.84,2.32,2.32,0,0,0,2.73-1.39l.17-.5.24.47a4.81,4.81,0,0,0,1.79,2.22,1.56,1.56,0,0,0,2.15-.57l.21-.63.2.64a3,3,0,0,0,2,1.84,3,3,0,0,0,2.56-.35l.35-.27v.45a2,2,0,0,0,1.86,2,2,2,0,0,0,2-1.65l0-.18h.18l5.61,0a14,14,0,0,0,5.31-.75,9.53,9.53,0,0,0,2.29-1.28,9.76,9.76,0,0,1,1.1-.8A2,2,0,0,1,372,145a13.15,13.15,0,0,0,2.52.56,9.17,9.17,0,0,0,2.51-.14,8.74,8.74,0,0,0,4.32-2.22,4.69,4.69,0,0,1,1-.8,2.88,2.88,0,0,1,1.26-.3,18.72,18.72,0,0,0,2.39-.14,15.62,15.62,0,0,0,2.3-.47,5.54,5.54,0,0,0,2-1,2,2,0,0,0,.78-1.85,1.42,1.42,0,0,0-1.26-1.34h-.15l0-.16a3,3,0,0,1,.33-1.82,1.83,1.83,0,0,1,1.56-.93,1.29,1.29,0,0,1,1.39,1,1.2,1.2,0,0,1-.9,1.42l.07-.29a1.82,1.82,0,0,0,2-.13,2,2,0,0,0,1-1.79,2.91,2.91,0,0,0-2.87-2.51h-.19l0-.19a6.67,6.67,0,0,0,.09-3.31l-.13-.6.38.49a2.37,2.37,0,0,0,3.19.36l.12-.09.08.12a4.43,4.43,0,0,0,2.05,1.77,2.72,2.72,0,0,0,2.47-.21,1.81,1.81,0,0,0,.86-2.05,1.65,1.65,0,0,0-1.63-1.26l-.22,0,.11-.2a2.11,2.11,0,0,0-1.86-3l-.12,0,0-.13a3.36,3.36,0,0,0-2-3.55l.07-.15a1.73,1.73,0,0,0,2.46-.94l0-.15.09.13a1.63,1.63,0,0,0,1.36.73,3.57,3.57,0,0,0,1.41-.22,4.38,4.38,0,0,0,1.84-1.22,2.09,2.09,0,0,0,.45-1.24C403.24,116.94,403.2,116.79,403.21,116.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.2,157.57c-.09-2.95-.16-5.27-.13-5.27s10.07-1.45,10.31-11.5c.12-4.85-.46-14.86-1.08-23.92a18.73,18.73,0,0,0-18.47-17.44h-1c-10.46.49-15.89,9.65-15.12,20.09l1.07,38.24,6,14.55c5.94,6.51,18.77-5.93,18.43-14.74Z",
    style: {
      fill: "#c78976"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.13,152.29a24.3,24.3,0,0,1-13.05-4s3,7.7,13.05,6.91Z",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.42,125.83a1.44,1.44,0,0,1-1.4,1.43,1.39,1.39,0,0,1-1.47-1.31,1.44,1.44,0,0,1,1.4-1.44A1.39,1.39,0,0,1,383.42,125.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.16,121c-.18.18-1.26-.64-2.8-.65s-2.69.74-2.85.55.1-.42.6-.77a4,4,0,0,1,2.28-.68,3.8,3.8,0,0,1,2.23.75C385.09,120.59,385.25,120.93,385.16,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,126.57a1.43,1.43,0,0,1-1.4,1.43,1.36,1.36,0,0,1-1.46-1.31,1.42,1.42,0,0,1,1.39-1.43A1.37,1.37,0,0,1,369.79,126.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,121.46c-.18.19-1.26-.63-2.8-.64s-2.69.74-2.85.55.1-.42.6-.77a4,4,0,0,1,2.28-.68,3.78,3.78,0,0,1,2.23.75C370,121,370.11,121.38,370,121.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.42,133.4a10,10,0,0,1,2.52-.43c.39,0,.77-.11.84-.38a2.11,2.11,0,0,0-.25-1.17c-.36-1-.74-2-1.13-3-1.57-4.3-2.71-7.83-2.53-7.89s1.58,3.37,3.15,7.66l1.09,3a2.29,2.29,0,0,1,.18,1.55,1,1,0,0,1-.65.57,3,3,0,0,1-.67.08A10.6,10.6,0,0,1,375.42,133.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,116.25c-.16.42-1.7.2-3.51.4s-3.29.68-3.52.31c-.11-.19.15-.58.74-1a6.14,6.14,0,0,1,5.36-.54C370.18,115.72,370.52,116.05,370.45,116.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6,115.81c-.27.36-1.34,0-2.62,0s-2.36.26-2.61-.1c-.11-.18.05-.53.52-.87a3.73,3.73,0,0,1,2.12-.6,3.61,3.61,0,0,1,2.1.69C384.56,115.28,384.71,115.64,384.6,115.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.92,137.37a6.44,6.44,0,0,1-.76,1.69,2.2,2.2,0,0,1-1.51,1,2,2,0,0,1-1.71-.83,3.13,3.13,0,0,1-.55-1.86c0-.6.23-1.32.82-1.42a1.54,1.54,0,0,1,.73.12l3.17,1.11",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.8,140a4.75,4.75,0,0,1-1.67-.12,2.41,2.41,0,0,1-1.31-1.08,2.5,2.5,0,0,1-.14-2,2.17,2.17,0,0,1,.25-.48c.12-.14.1-.13.23-.12s.34.12.51.17l.52.19c.68.23,1.29.44,1.81.6a5.47,5.47,0,0,0,1.72.43,5.61,5.61,0,0,0-1.58-.79c-.5-.22-1.1-.46-1.77-.72l-.52-.2a4.62,4.62,0,0,0-.58-.21.69.69,0,0,0-.46,0,.86.86,0,0,0-.33.28,3,3,0,0,0-.32.61,2.91,2.91,0,0,0,.22,2.48,2.6,2.6,0,0,0,1.64,1.2,2.5,2.5,0,0,0,1.35,0C375.67,140.13,375.81,140,375.8,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.94,108.52a12.32,12.32,0,0,0-.22-1.5,4.64,4.64,0,0,0-1.34-1.88c-1.92-1.89-3.95-3.83-6.36-4.46-1.48-.38-3-.24-4.49-.6a27.9,27.9,0,0,1-2.68-1,22,22,0,0,0-11.39-.61,18.31,18.31,0,0,0-6.12,2,22.25,22.25,0,0,0-5.48,5,33.48,33.48,0,0,0-6.11,9.84,16.28,16.28,0,0,0-.88,9.29c.73,3.1,2.92,5.88,5.59,6.31l.94-1.28,1.49-1.88c-.25.75,0,.7.63,1a1.27,1.27,0,0,0,1.77-.65c.54.61,1.59-.15,1.37-1,.63.29,1.34-.58,1.09-1.32.72.21,1-1,1.34-1.74.16-.42.41-.8.61-1.2a7.78,7.78,0,0,0,.8-4.28,7.75,7.75,0,0,0,1-4.2c0-.93.07-1.86.11-2.79.15-.23.3-.46.46-.69a1.49,1.49,0,0,0,1.11,1.35,3.19,3.19,0,0,0,1.67-.16l1.62-.46,1.06.21a4.23,4.23,0,0,0,.52,2.67A2.61,2.61,0,0,0,369.1,116a.79.79,0,0,0,1-.93.86.86,0,0,0,1.32-.32,2.86,2.86,0,0,0,.23-1.73,7.31,7.31,0,0,0-1.65-3.89l3.08,2.45a1.31,1.31,0,0,0,.74.37.76.76,0,0,0,.88.77,2,2,0,0,0,1-.8c.64-.79,1.27-2.1.58-2.87a.64.64,0,0,0,.21-.94l3.45,2.21c-.34-.16-.66.38-.55.79a1.73,1.73,0,0,0,.75.91,2.55,2.55,0,0,0-.24,1.57c-.63-.48-1.43.57-1.17,1.39a1.85,1.85,0,0,0,1.83,1.21,1.3,1.3,0,0,0,1.37-1.07c.72.09,1.33-1,1-1.73.55.3.92-.66.89-1.37a10.21,10.21,0,0,0-.81-3.58.19.19,0,0,0,.27.06.25.25,0,0,0,.06-.14l2.05,4a10.26,10.26,0,0,1,1.31,3.64c.06.53.18,1.26.63,1.27a.54.54,0,0,0,.34-.12,6.77,6.77,0,0,0,2.66-3.65,5.42,5.42,0,0,0,.32-1.61A22.21,22.21,0,0,0,389.94,108.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.62,107.12a1.62,1.62,0,0,0,.35-.83,1.11,1.11,0,0,0-.36-.91,1.18,1.18,0,0,0-1.21-.21l-.25.11.09-.26a1.23,1.23,0,0,0-.45-1.34,1.2,1.2,0,0,0-1.53.19l-.22-.18a.39.39,0,0,0,.07-.16A.67.67,0,0,0,372,103a.79.79,0,0,0-.53-.28,1.41,1.41,0,0,0-.61.08,1.6,1.6,0,0,1-.68.22c-.3,0-.45-.24-.61-.32a2.23,2.23,0,0,0-.51-.26,2.57,2.57,0,0,0-1-.14,2.71,2.71,0,0,0-1.41.47c-.3.2-.42.36-.44.35a1.18,1.18,0,0,1,.37-.44,2.69,2.69,0,0,1,1.47-.58,2.88,2.88,0,0,1,1.1.12,2.62,2.62,0,0,1,.56.27c.19.11.34.27.49.27a1.55,1.55,0,0,0,.57-.21,1.71,1.71,0,0,1,.75-.1,1.08,1.08,0,0,1,.71.37,1,1,0,0,1,.21.82,1.23,1.23,0,0,1-.12.26l-.22-.18a1.47,1.47,0,0,1,1.9-.22,1.46,1.46,0,0,1,.51,1.64l-.16-.15a1.4,1.4,0,0,1,1.44.28,1.22,1.22,0,0,1,.36,1.07,1.2,1.2,0,0,1-.28.66A.89.89,0,0,1,375.62,107.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,108.31a1.84,1.84,0,0,0,.46-.82,1.38,1.38,0,0,0-.15-1,1.45,1.45,0,0,0-1.16-.69h-.2l.12-.17a1.74,1.74,0,0,0,.35-1.55.92.92,0,0,0-.61-.57.72.72,0,0,0-.81.17l-.72.91.49-1.05a1.43,1.43,0,0,0,0-1.21,1.3,1.3,0,0,0-1-.74,1.38,1.38,0,0,0-.92.17l-.31.19.1-.35c.15-.49-.38-1-.87-1A2.34,2.34,0,0,0,376,101l-.26.17.06-.3a1,1,0,0,0-.42-1,1.84,1.84,0,0,0-1-.34,4.81,4.81,0,0,0-1.77.19,6.73,6.73,0,0,0-1.45.67s.1-.12.33-.28a4.8,4.8,0,0,1,2.91-.79,2.17,2.17,0,0,1,1.11.36,1.28,1.28,0,0,1,.52,1.2l-.19-.13a2.58,2.58,0,0,1,1.6-.55,1.32,1.32,0,0,1,.85.41,1,1,0,0,1,.26,1l-.21-.16a1.78,1.78,0,0,1,1.11-.21,1.59,1.59,0,0,1,1.23.9,1.68,1.68,0,0,1,0,1.45l-.22-.15a1,1,0,0,1,1.1-.25,1.19,1.19,0,0,1,.76.74,1.91,1.91,0,0,1-.41,1.76l-.08-.17a1.62,1.62,0,0,1,1.29.83,1.48,1.48,0,0,1,.13,1.16,1.67,1.67,0,0,1-.37.63C382.76,108.28,382.68,108.32,382.68,108.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.68,108.32a1,1,0,0,0-.42-.73,1.38,1.38,0,0,0-.95-.25,4,4,0,0,0-1.3.43l-.15.07v-.17a1.2,1.2,0,0,0-1.07-1.08,3.49,3.49,0,0,0-1.94.48l-.84.4.69-.61a1,1,0,0,0-.19-1.41,2.23,2.23,0,0,0-1.77-.26h-.08l-.54.1.43-.35a1.07,1.07,0,0,0-.26-1.66,1.63,1.63,0,0,0-1.77.33l-.53.5.33-.66a2.38,2.38,0,0,0-.22-2.43,2.21,2.21,0,0,0-1.73-.9,2.45,2.45,0,0,0-1.29.28c-.28.14-.4.26-.42.25l.09-.1a1.7,1.7,0,0,1,.29-.23,2.44,2.44,0,0,1,1.34-.36,2.4,2.4,0,0,1,1.9.93,2.64,2.64,0,0,1,.27,2.68l-.2-.15a1.83,1.83,0,0,1,2.06-.38,1.32,1.32,0,0,1,.69,1,1.18,1.18,0,0,1-.38,1.16l-.11-.25h.09a2.47,2.47,0,0,1,2,.32,1.42,1.42,0,0,1,.5.88,1,1,0,0,1-.3.94l-.14-.22a3.74,3.74,0,0,1,2.09-.48,1.4,1.4,0,0,1,1.23,1.33l-.14-.1a4.29,4.29,0,0,1,1.37-.4,1.44,1.44,0,0,1,1,.33,1,1,0,0,1,.36.58C397.71,108.24,397.69,108.32,397.68,108.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.66,94.82s-.11.09-.36.16a4.77,4.77,0,0,1-1.07.15,3.16,3.16,0,0,0-1.54.37,1,1,0,0,0-.49.72.72.72,0,0,0,.36.79l-.18.15c-.09-.35-.55-.54-1-.74a4.67,4.67,0,0,0-1.35-.45,1.69,1.69,0,0,0-1.31.32,1.12,1.12,0,0,0-.49,1.08l.08.33-.28-.2a3.07,3.07,0,0,0-1.88-.59,3.43,3.43,0,0,0-1.54.35,4.47,4.47,0,0,0-1.13.87,1,1,0,0,1,.21-.33,3,3,0,0,1,.84-.68,3.65,3.65,0,0,1,1.61-.44,3.24,3.24,0,0,1,2,.61l-.2.13a1.37,1.37,0,0,1,.57-1.35,2,2,0,0,1,1.51-.38,4.79,4.79,0,0,1,1.44.48,6.61,6.61,0,0,1,.64.34,1,1,0,0,1,.47.59l.06.26-.24-.11a1,1,0,0,1-.5-1.07,1.21,1.21,0,0,1,.61-.87,3.26,3.26,0,0,1,1.65-.34,8.28,8.28,0,0,0,1.06-.07A2,2,0,0,1,388.66,94.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.38,90.65a3.07,3.07,0,0,0-.72.17,1.73,1.73,0,0,0-.66.5,1.5,1.5,0,0,0-.36,1v.16l-.15,0a.93.93,0,0,0-1,.66,2.74,2.74,0,0,0,.08,1.54l.13.54-.38-.42-.06-.06a1.2,1.2,0,0,0-1-.32,1.34,1.34,0,0,0-.88.48,2.14,2.14,0,0,0-.42,1.69,4,4,0,0,0,.42,1.18,2.1,2.1,0,0,1,.21.42s-.13-.11-.31-.36a3.72,3.72,0,0,1-.51-1.2,2.3,2.3,0,0,1,.41-1.9,1.56,1.56,0,0,1,2.27-.19l.08.09-.25.12a3,3,0,0,1-.05-1.7,1.15,1.15,0,0,1,1.28-.8l-.15.11a1.81,1.81,0,0,1,1.21-1.6,1.47,1.47,0,0,1,.57-.08C374.32,90.62,374.38,90.64,374.38,90.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.93,100.16s-.14,0-.38,0a2.37,2.37,0,0,1-.89-.52,2.54,2.54,0,0,1-.76-1.34,1.25,1.25,0,0,0-.25-.75c-.17-.18-.52-.28-.76-.58a1.4,1.4,0,0,1,.2-1.91v.2a4.58,4.58,0,0,1-1.33-1.55,1.8,1.8,0,0,1-.26-.75s.14.26.4.67A4.79,4.79,0,0,0,360.24,95l.14.1-.13.11a1.15,1.15,0,0,0-.14,1.53c.16.23.48.32.74.57a1.5,1.5,0,0,1,.31.89,2.4,2.4,0,0,0,.64,1.25A3.48,3.48,0,0,0,362.93,100.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.55,102.92s-.08,0-.23.06a3.66,3.66,0,0,1-.67,0,3.79,3.79,0,0,1-2.16-1h.18a2.38,2.38,0,0,1-1.56,1,2.54,2.54,0,0,1-1.06,0,1.53,1.53,0,0,1-.94-.62,3,3,0,0,1-.15-.39.53.53,0,0,0-.2-.25,1.72,1.72,0,0,0-.66-.23,2.25,2.25,0,0,1-.75-.23.8.8,0,0,1-.45-.65l.18.11a2.45,2.45,0,0,1-1.7.18,2.64,2.64,0,0,1-1.17-.6,2.29,2.29,0,0,1-.53-.68.73.73,0,0,1-.09-.29,3.37,3.37,0,0,0,.71.85,2.63,2.63,0,0,0,1.13.51,2.2,2.2,0,0,0,1.53-.2l.19-.09v.2a.56.56,0,0,0,.33.43,2.19,2.19,0,0,0,.67.19,1.94,1.94,0,0,1,.78.28.8.8,0,0,1,.29.36c.06.15.08.27.13.36a1.32,1.32,0,0,0,.78.49,2.26,2.26,0,0,0,.93,0,2.19,2.19,0,0,0,1.41-.88l.09-.11.1.1a3.76,3.76,0,0,0,2,1C359.22,102.94,359.55,102.89,359.55,102.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,113.4s0,0,0-.09a1.76,1.76,0,0,1-.07-.29,2.72,2.72,0,0,1,0-1.12,6.52,6.52,0,0,1,.61-1.63,5.85,5.85,0,0,1,.55-.94,1.62,1.62,0,0,1,.45-.41.71.71,0,0,1,.68-.06l-.16.13a1.86,1.86,0,0,1,2.89-1.88l-.22.13a1.28,1.28,0,0,1,.43-1.09,1.26,1.26,0,0,1,1.18-.25,1.32,1.32,0,0,1,.58.37l-.24.12a.76.76,0,0,1,.24-.68,1.11,1.11,0,0,1,.6-.32,2.54,2.54,0,0,1,1.22.2l-.16.07a2,2,0,0,1,1.13-1,2.82,2.82,0,0,1,1.37-.12,7.38,7.38,0,0,1,2.2.87l-.14.14a.5.5,0,0,1,0-.49.74.74,0,0,1,.32-.29,1.41,1.41,0,0,1,.73-.18,4.05,4.05,0,0,1,1.14.24,3.39,3.39,0,0,1,.66.32.77.77,0,0,1,.21.15s-.31-.17-.9-.36a4.19,4.19,0,0,0-1.11-.19,1.27,1.27,0,0,0-.64.18c-.2.11-.37.33-.25.52l.18.3-.32-.16a7,7,0,0,0-2.13-.8,2.55,2.55,0,0,0-1.25.12,1.72,1.72,0,0,0-1,.82l-.05.11-.11,0a2.35,2.35,0,0,0-1.09-.19c-.33,0-.67.36-.61.68l.08.49-.33-.37a1,1,0,0,0-.45-.29,1,1,0,0,0-.91.19,1,1,0,0,0-.34.85l0,.3-.25-.17a1.64,1.64,0,0,0-1.85,0,1.7,1.7,0,0,0-.65,1.59l0,.22-.2-.1c-.32-.15-.66.13-.87.4a5.94,5.94,0,0,0-.55.89,6.91,6.91,0,0,0-.65,1.57A3.72,3.72,0,0,0,338.25,113.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,121.45a1.09,1.09,0,0,1-.15-.17,4.74,4.74,0,0,1-.38-.53,2,2,0,0,1-.31-1,1.42,1.42,0,0,1,.16-.65,1.06,1.06,0,0,1,.57-.53l0,.16a1.35,1.35,0,0,1-.17-1.38,1.33,1.33,0,0,1,1.4-.74l-.12.21a1.06,1.06,0,0,1-.06-1.25,1.59,1.59,0,0,1,1.14-.66,5.56,5.56,0,0,0,.63-.05c.17,0,.27-.17.35-.37a2.61,2.61,0,0,1,.31-.63,1.16,1.16,0,0,1,.63-.42,6.6,6.6,0,0,1,1.48-.17,1.6,1.6,0,0,0,1.18-.45,4.77,4.77,0,0,0,.34-.57,1.46,1.46,0,0,1,1.84-.52l-.15.19a1.11,1.11,0,0,1,0-1.3,1.58,1.58,0,0,1,1-.61,5,5,0,0,1,1.85.07,6.31,6.31,0,0,1,1.13.34,1.46,1.46,0,0,1,.37.19s-.54-.22-1.53-.39a5.26,5.26,0,0,0-1.78,0,1.32,1.32,0,0,0-.85.53.89.89,0,0,0,0,1l.33.42-.48-.23a1.21,1.21,0,0,0-1.08,0,1.27,1.27,0,0,0-.43.4,5.65,5.65,0,0,1-.35.59,1.51,1.51,0,0,1-.63.43,3.11,3.11,0,0,1-.73.13,6.5,6.5,0,0,0-1.42.16.91.91,0,0,0-.5.32,1.89,1.89,0,0,0-.27.57.84.84,0,0,1-.54.53,6,6,0,0,1-.66.06,1.27,1.27,0,0,0-1,.52.81.81,0,0,0,0,.94l.24.27-.36-.06a1.1,1.1,0,0,0-1.14.59,1.14,1.14,0,0,0,.12,1.16l.09.11-.14,0a1.06,1.06,0,0,0-.63,1,1.83,1.83,0,0,0,.25,1A8.51,8.51,0,0,1,340.51,121.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.64,136.62a.62.62,0,0,1-.28-.07,1.94,1.94,0,0,1-.68-.44,2,2,0,0,1-.57-1.15,2.15,2.15,0,0,1,.44-1.61v.15a4,4,0,0,1-.85-1.32,1.72,1.72,0,0,1,0-.9,1.21,1.21,0,0,1,.6-.75v.25a1.62,1.62,0,0,1-.82-1.4,1.73,1.73,0,0,1,.21-.94,1.5,1.5,0,0,1,.67-.63c.26-.15.37-.28.35-.55a2.2,2.2,0,0,1,.12-.84,2.87,2.87,0,0,1,.94-1.2c.36-.3.68-.59,1-.84a4.8,4.8,0,0,1,1.64-.95,2.74,2.74,0,0,1,.51-.09c.12,0,.18,0,.18,0s-.25,0-.66.17a5.23,5.23,0,0,0-1.54,1l-1,.87a2.63,2.63,0,0,0-.86,1.11,2,2,0,0,0-.09.75.83.83,0,0,1-.11.47,1.15,1.15,0,0,1-.37.31,1.35,1.35,0,0,0-.74,1.33,1.33,1.33,0,0,0,.67,1.16l.25.13-.26.12a1.12,1.12,0,0,0-.46,1.32,3.73,3.73,0,0,0,.78,1.25l.06.08-.06.07a2,2,0,0,0-.43,1.44,1.9,1.9,0,0,0,.48,1.07A3,3,0,0,0,339.64,136.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.08,112a2.22,2.22,0,0,1-.86-.26,2.41,2.41,0,0,1-.81-.59,1.54,1.54,0,0,1-.37-1.19,1,1,0,0,1,.09-.3l.07.19a1.33,1.33,0,0,1-.76-.87,1.18,1.18,0,0,1,.1-.92c.26-.47.62-.55.62-.52s-.27.18-.45.6a1.06,1.06,0,0,0,0,.77,1.11,1.11,0,0,0,.63.68l.13,0-.06.13a1,1,0,0,0-.06.23,1.34,1.34,0,0,0,.3,1,2.38,2.38,0,0,0,.69.57A4.48,4.48,0,0,1,363.08,112Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.32,108.39a1.77,1.77,0,0,0,.11-1,1.2,1.2,0,0,0-.74-.82,1.25,1.25,0,0,0-1.31.33l-.16.18-.07-.24a2.25,2.25,0,0,0-.39-.79,1,1,0,0,0-.74-.44c-.45,0-.92.43-.76.79l-.26.08a2.17,2.17,0,0,0-.89-1.33,2.11,2.11,0,0,0-1.23-.36,3.22,3.22,0,0,0-1.16.32s.08-.1.26-.21a2.17,2.17,0,0,1,2.26.06,2.31,2.31,0,0,1,1,1.46l-.26.08a.8.8,0,0,1,.21-.84,1.11,1.11,0,0,1,.82-.33,1.34,1.34,0,0,1,1,.54,2.63,2.63,0,0,1,.42.9l-.22,0a1.48,1.48,0,0,1,1.59-.36,1.31,1.31,0,0,1,.81,1,1.24,1.24,0,0,1-.09.83C369.41,108.33,369.33,108.4,369.32,108.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,127c-.17-.08-6.89-2.12-6.75,4.75s7,5.32,7,5.12S353.54,127,353.54,127Z",
    style: {
      fill: "#c78976"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,134.28s-.12.08-.32.18a1.14,1.14,0,0,1-.89,0,3,3,0,0,1-1.43-2.63,3.94,3.94,0,0,1,.3-1.72,1.38,1.38,0,0,1,.89-.94.61.61,0,0,1,.71.31c.09.19.05.33.09.34s.15-.12.08-.4a.77.77,0,0,0-.27-.42.94.94,0,0,0-.67-.17,1.69,1.69,0,0,0-1.23,1.1,4.13,4.13,0,0,0-.38,1.92c.08,1.38.81,2.67,1.81,2.93a1.25,1.25,0,0,0,1.09-.2C351.65,134.44,351.69,134.29,351.66,134.28Z",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.34,156.36l2.29-4.83s1.95,10.86,6.22,15.26l5.07,5.52.22-2.44,13.06-12.3-.17-3.94,5.47,7.25,10.2,9.18-14.85,82.33-1,10.63-30.67-4.13L339,204.79s-2.6-28.44-2.37-28.06,3-11.2,3-11.2l9.82-5.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,167.89s-5.73,4.68-7.78,15.07-9.46,48.48-9.46,51.82c0,0,3.43,16.1,7.72,26.06,3.86,9,8.3,17,8.72,16.59l9.86-12L326,231.73l.58-2.72,1.86-5,3.12-15.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.57,248.1,329.21,228l-.57-4.91-3.13-29.29-1.64-25.87,21.26-7.74,2.06-.75,4.11-4.19,1.3,41.72s.62,33.84.21,36.6-4.3,42.13-18,54.91c0,0-5.46,6.61-7.6,5.18s-7.43-25.22-7.43-25.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63,158.94s-.08.16-.28.45l-.88,1.24-3.38,4.61,0,0-.05,0-2.92,1.08.12-.21c1.39,6.81,3.32,16.27,5.45,26.74,2,10.32,3.9,19.65,5.25,26.48l1.53,8q.24,1.36.39,2.19a4.39,4.39,0,0,1,.1.77,3.41,3.41,0,0,1-.2-.75c-.13-.54-.29-1.26-.49-2.17-.41-1.94-1-4.66-1.69-8-1.39-6.82-3.3-16.14-5.4-26.45-2.07-10.48-3.95-19.95-5.3-26.77l0-.15L340,166l2.94-1-.07.06,3.49-4.52c.4-.49.71-.89.95-1.19A2.72,2.72,0,0,1,347.63,158.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06,155l5.88,5.48,20.59,11.09-6,25.5-2.05,31.31,2.88,19.74,7.1,37.21s-24.93,6.76-27.84,5.24-2.51-5.84-2.61-6.14-4.53-37.69-4.53-37.69l-.9-14.47s-.4-24.82,1.31-30.35,4.22-23.61,5.12-28.64,1.93-8.41,2.54-10.95a25.08,25.08,0,0,0,.7-4.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.85,250.7a56.85,56.85,0,0,0,1.35,9.38,73.68,73.68,0,0,0,14.37-3.19c-.81-2.18-1.61-4.37-2.42-6.55a2.33,2.33,0,0,0-.85-1.3,2.36,2.36,0,0,0-1.6-.11l-10.85,1.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.85,250.7a11.48,11.48,0,0,1,1.61-.36l4.44-.81L398,249l1.72-.3a4.24,4.24,0,0,1,1-.08,1.62,1.62,0,0,1,1,.4,4.88,4.88,0,0,1,.94,1.82l.71,1.91c.48,1.31,1,2.66,1.5,4.05l.09.25-.25.08-1.45.47a71.06,71.06,0,0,1-13,2.69l-.19,0,0-.18a42.75,42.75,0,0,1-1-6.85c-.06-.82-.1-1.47-.12-1.9a3.25,3.25,0,0,1,0-.68,3.08,3.08,0,0,1,.12.66c.06.51.14,1.14.23,1.9a49.19,49.19,0,0,0,1.21,6.76l-.23-.15a77.53,77.53,0,0,0,12.87-2.77l1.43-.46-.16.34c-.51-1.39-1-2.75-1.48-4.05l-.7-1.92a4.33,4.33,0,0,0-.8-1.64,1.82,1.82,0,0,0-1.57-.23l-1.72.27-3.1.47-4.46.65A11.31,11.31,0,0,1,388.85,250.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.35,289.69a1.49,1.49,0,0,1-.13-.37l-.32-1.11c-.28-1-.68-2.45-1.17-4.26l-4.15-15.5v-.06l0-.06L327.34,248l0,.07c.32-4,.66-8.13,1-12.41.22-2.65.43-5.25.63-7.73v0c-1.22-13.65-2.56-25.69-3.37-34.34-.42-4.32-.73-7.8-.93-10.19-.08-1.17-.15-2.09-.2-2.75,0-.29,0-.53,0-.71a.81.81,0,0,1,0-.25,1.17,1.17,0,0,1,0,.24c0,.19.05.42.08.71.08.66.17,1.58.3,2.74.26,2.43.62,5.89,1.08,10.18.91,8.64,2.3,20.67,3.54,34.33v0c-.2,2.48-.41,5.08-.62,7.73-.35,4.28-.69,8.45-1,12.41v.07c-2.91,7.54-5.59,14.46-7.84,20.28v-.12c1.66,6.48,3,11.8,4,15.54l1.06,4.29c.11.47.2.84.27,1.12A3,3,0,0,1,325.35,289.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.53,229.59a5.39,5.39,0,0,1,1.89-.31,19.16,19.16,0,0,1,4.6.32,19.81,19.81,0,0,1,4.39,1.39,5.46,5.46,0,0,1,1.65.95,60.55,60.55,0,0,0-6.14-1.83A46.16,46.16,0,0,0,313.53,229.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,230.37a4.45,4.45,0,0,1,.16-.76c.14-.54.33-1.25.57-2.14.53-1.92,1.28-4.59,2.2-7.87L382,193.68c3-10.12,5.64-19.28,7.57-25.86l0,.18-4.6-4.79,0,0v0L383.7,160c-.12-.33-.22-.6-.31-.81a1.19,1.19,0,0,1-.08-.29.94.94,0,0,1,.14.26l.37.79q.48,1.13,1.35,3.09l0,0,4.7,4.7.07.08,0,.1c-1.89,6.59-4.52,15.77-7.42,25.91l-7.57,25.87-2.35,7.82-.67,2.12A5.65,5.65,0,0,1,371.61,230.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.86,184.63a6.07,6.07,0,0,1,.22-2.21,15.83,15.83,0,0,1,5.64-8.95,6.66,6.66,0,0,1,1.89-1.16c.12.14-2.86,1.91-5,5.43A24.63,24.63,0,0,0,396.86,184.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M396.71,239.31l-6.5-4.41a32.07,32.07,0,0,0-7.38-4.12c-2-.71-4.2-1-6.26-1.65a9.62,9.62,0,0,1-5.05-4.12c0,1,.05,2.78.09,3.78.22,1.84,1.94,2.8,3.61,3.6s3.53,1.38,4.79,2.73c.76.81,1.24,1.83,1.92,2.7a13.07,13.07,0,0,0,5.87,3.75,49.06,49.06,0,0,0,10.85,2.74,1.14,1.14,0,0,0,.91-.13,1,1,0,0,0,.27-.74C399.87,241.64,398.21,240.32,396.71,239.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M405.53,171.55s3.76,1.6,5.28,8.45,10.05,48.41,9.89,52.67-2.13,7.46-5.93,8.83a21.9,21.9,0,0,1-11.88,1.07,125,125,0,0,1-14.9-3.9,29,29,0,0,1-5.08-2.25,25.46,25.46,0,0,1,.59-9.16c1.25-4.46,6-10.3,6-10.3l12,3.69-3.17-14.34,3.78-30.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.52,220.65a7,7,0,0,1,2.19.89,19.53,19.53,0,0,1,4.6,3.39,19.92,19.92,0,0,1,3.41,4.58,7.47,7.47,0,0,1,.9,2.19,33,33,0,0,0-4.68-6.4A32.29,32.29,0,0,0,401.52,220.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,226.37c-.08,0-.65-.74-1.78-1.78a16,16,0,0,0-10.94-4.22c-1.54,0-2.49.22-2.51.13s.22-.12.65-.23a11.11,11.11,0,0,1,1.85-.27,14.57,14.57,0,0,1,11.21,4.32,9.51,9.51,0,0,1,1.18,1.45A1.86,1.86,0,0,1,416.65,226.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.35,206.31a1.26,1.26,0,0,1,.08.25c.05.2.12.44.19.74l.69,2.85c.59,2.54,1.41,6.1,2.41,10.45l.08.34-.34-.1-12-3.65.19,0a12.1,12.1,0,0,0-4.37,4.47,18,18,0,0,0-2.08,6.41,25.27,25.27,0,0,0-.28,4.23,27.47,27.47,0,0,0,.3,4.1l-.11-.17a24.29,24.29,0,0,0,6.05,2.55c2,.61,4,1.08,5.92,1.53s3.68.9,5.31,1.38a29.73,29.73,0,0,0,4.61.86,24,24,0,0,0,6.69-.22c.77-.15,1.36-.3,1.76-.4a4.71,4.71,0,0,1,.61-.15,2.18,2.18,0,0,1-.58.23,14.35,14.35,0,0,1-1.76.49,22.25,22.25,0,0,1-6.75.38,29.13,29.13,0,0,1-4.68-.81c-1.65-.47-3.42-.89-5.31-1.32s-3.9-.9-6-1.5a24.78,24.78,0,0,1-6.2-2.59l-.09-.06,0-.11a28.86,28.86,0,0,1-.31-4.18,26.15,26.15,0,0,1,.28-4.31,18.65,18.65,0,0,1,2.15-6.6,12.59,12.59,0,0,1,4.58-4.64l.09-.05.1,0,12,3.74-.25.23c-.93-4.37-1.7-7.95-2.24-10.49-.24-1.21-.44-2.17-.58-2.88-.05-.3-.1-.54-.14-.75A1,1,0,0,1,398.35,206.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29,224s.34-18.28.57-19,.38-1.15,2-1.27,12.87-.54,13.78-.21c.65.25.79.88.79,1.7,0,3.58-.75,15.53-1,19.88a1.69,1.69,0,0,1-1.71,1.58l-13.34-.19a1.12,1.12,0,0,1-1.1-1.12Z",
    style: {
      fill: "#E59B40"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.67,
    y: 206.31,
    width: 2.09,
    height: 4.71,
    rx: 1.02,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.21,210s1.11-.8,1.51,0,7.2,10.61,7.2,10.61a16.49,16.49,0,0,1-.27,5.25,19.51,19.51,0,0,1-2.61,6.15l-2.21-2s-5.43.91-6.43.7-6.72-2.77-8-4.28a20.69,20.69,0,0,0-3.23-2.85l-5.64-3.82a1.89,1.89,0,0,1-.76-1,1.33,1.33,0,0,1,.49-1.52,1.63,1.63,0,0,1,1.68-.29s-.39-1.89.92-2.19,14.27,4.32,14.27,4.32a1.66,1.66,0,0,0,1.1-.61c.3-.5-9.24-3.11-9.44-4.12s.6-2.11,2.21-2.11,9,1.61,9,1.61Z",
    style: {
      fill: "#c78976"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.93,219c0,.06-.22.27-.71.41a4.23,4.23,0,0,1-2,0,4.78,4.78,0,0,1-2.42-1.19,13.1,13.1,0,0,1,2.53.68A10.08,10.08,0,0,0,384.93,219Z",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,214.41c0,.14-.75.12-1.61,0s-1.53-.43-1.51-.57.75-.11,1.61.06S385.09,214.27,385.06,214.41Z",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.18,224.34a11.63,11.63,0,0,1-2.56-.61,48.89,48.89,0,0,1-11.57-5.24,10.9,10.9,0,0,1-2.14-1.53,16.57,16.57,0,0,1,2.33,1.21c1.42.78,3.4,1.82,5.64,2.84s4.33,1.82,5.85,2.37A15.89,15.89,0,0,1,380.18,224.34Z",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.51,227.26a12.87,12.87,0,0,1-5.13-1.23,13.16,13.16,0,0,1-4.49-2.76c.09-.13,2,1.19,4.69,2.28S377.53,227.1,377.51,227.26Z",
    style: {
      fill: "#8b5d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34,216.74s.25.23.56.73a9,9,0,0,1,1,2.31,12.25,12.25,0,0,1-.58,8.18,25.68,25.68,0,0,1-1.95,4.11,11.18,11.18,0,0,1-2.48,2.8,12.71,12.71,0,0,1-2.08,1.41,3,3,0,0,1-.84.37c-.06-.09,1.13-.68,2.68-2.06a11.57,11.57,0,0,0,2.31-2.77,27.42,27.42,0,0,0,1.88-4.06,12.56,12.56,0,0,0,.7-7.89A17.58,17.58,0,0,0,389.34,216.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "327.13 237.19 322.64 254.02 321.09 264.99 327.57 248.1 328.13 241.22 327.13 237.19"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364.92,172.31s-.31-.34-1-.85-1.72-1.11-3-2l.29-.12c-.11,1.17-.15,2.54-.15,4.06a45.78,45.78,0,0,1-.17,5l-.09.79-.39-.69c-.5-.9-1-1.82-1.6-2.75A98.75,98.75,0,0,1,353,165.11a28.62,28.62,0,0,1-1.26-3.47,6.06,6.06,0,0,1-.27-1.32,7.58,7.58,0,0,1,.47,1.26,36.52,36.52,0,0,0,1.4,3.38c1.3,2.81,3.51,6.48,5.95,10.54.56.94,1.1,1.87,1.6,2.77l-.48.09c.19-1.74.2-3.4.22-4.93a37.11,37.11,0,0,1,.25-4.1l0-.31.25.18a32.86,32.86,0,0,1,2.92,2.1,5.78,5.78,0,0,1,.68.72C364.88,172.2,364.94,172.31,364.92,172.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,163a2,2,0,0,1-.41.81,17.74,17.74,0,0,1-1.55,1.93c-1.38,1.56-3.41,3.59-5.72,5.77-1.48,1.4-2.9,2.69-4.12,3.78l-.23.19-.13-.25c-.8-1.57-1.46-2.89-1.91-3.82a7.87,7.87,0,0,1-.64-1.5,7.09,7.09,0,0,1,.88,1.38c.51.89,1.23,2.17,2.07,3.72l-.35-.06,4.07-3.82c2.3-2.17,4.37-4.16,5.81-5.64.72-.75,1.3-1.35,1.66-1.8S379.8,162.93,379.85,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,198.89a3.75,3.75,0,0,1-1.2.19,6,6,0,0,1-1.44-.05,3.21,3.21,0,0,1-1.79-.78,2.91,2.91,0,0,1-.82-2.21c0-.84,0-1.7,0-2.62.06-1.85.11-3.87.17-6,.13-4.24.28-8.08.41-10.86.08-1.31.14-2.41.19-3.29a4.81,4.81,0,0,1,.14-1.21,6.43,6.43,0,0,1,.06,1.21c0,.89,0,2,0,3.3,0,2.78-.13,6.63-.26,10.87-.07,2.12-.14,4.13-.21,6s-.45,3.63.56,4.56a3.1,3.1,0,0,0,1.58.76,8.34,8.34,0,0,0,1.38.13A10.48,10.48,0,0,1,368.45,198.89Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashHeroCrypto);
export default __webpack_public_path__ + "static/media/dash-hero-crypto.936146d21b94259ae06936cb4bc0299b.svg";
export { ForwardRef as ReactComponent };